import { Component, OnInit, AfterViewInit, ChangeDetectorRef, Input } from '@angular/core';
import { LanguageService } from '../services/language.service';
import { TranslateService } from '@ngx-translate/core';
import { CommunicationService } from "../services/communication.service";
import { ControllerService } from '../services/controller.service';
import * as compartments from "../../assets/smls/data/kha_compartments.json";
import { KHASystemService } from '../services/systems/kha-systems.service';
import { DatePipe } from '@angular/common';
import { ConfigService } from '../services/config.service';
import { DomSanitizer } from '@angular/platform-browser';
import jsPDF from 'jspdf';
import { element } from 'protractor';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';
import html2canvas from 'html2canvas';
import { GameService } from '../services/game.service';

declare var window;
@Component({
  selector: 'app-slms-sidepanel',
  templateUrl: './slms-sidepanel.component.html',
  styleUrls: ['./slms-sidepanel.component.scss'],
  providers: [DatePipe]
})

export class SlmsSidepanelComponent implements OnInit, AfterViewInit {
  compartList: any = [];
  panelWidth: any = '0px';
  slmsHandleToggleOpen: boolean = true;
  slmsPanelOpen: any = true;
  slmsControlPosition: any = 'Right';
  languageSelected: any = 'English';
  structHull: any = 'solid';
  structDecks: any = 'solid';
  structBulkheads: any = 'solid';
  structSections: any = 'solid';
  structOtherDecks: any = 'clear';
  deckList: any = ['02', '01', '1', 'M', '2', '3', '4', '5', '6'];
  mode: ProgressSpinnerMode = 'determinate';
  search: any = '';
  selectedDeck: any = ['2'];
  appMode: any;
  shipComp: any = {};
  shadowActive: boolean = false;
  broadcastSubs: any;
  compartmentList: any = [];
  currentComp = [];
  slms_mode;
  comps: any = [];
  showAllSystem: boolean = true;
  compartmentDeckList: any;
  filterComp: any = ['code', 'name'];
  sortComp: any;
  @Input() selectedKha: any = '';
  statusUpdated: any;
  sidepanelGroupTagpoint: any = [];
  layoutJson: any = [];
  groupJson: any = [];
  filterLayoutJson: any = [];
  selectedLayoutList: any = [];
  layoutCloseDetailData: any = [];
  showSelectedList: boolean = false;
  loadComparmentList: any = [];
  selectedId: any;
  selectedNotesId: any;
  layoutId: any;
  @Input() set _testMode(v: any) {
    if (v.includes("game-mode")) {
      this.slmsHandleToggleOpen = false;
      this.pathAnim = true;
    }
  }
  appGameModeContrl: any;
  @Input() set appGameMode(v: any) {
    if (v == true) {
      this.showPanelOpen = false;
      this.showGroupPanelOpen = false;
      this.showReportPanelOpen = false;
      this.showStatusPanelOpen = false;
      this.appGameModeContrl = true;
      this.showGamePanel = true;
    }
    if (v == false) {
      this.appGameModeContrl = false;
      this.showGamePanel = false;
    }
  }
  @Input() compToggle:any;
  groupStatusColor = "#ffff"
  StatusColorValue = '#fff'
  // group & layout
  showPanelOpen: any = true;
  showGroupPanelOpen: any = true;
  shipHandleToggleOpen: boolean = false;
  shipGroupHandleToggleOpen: boolean = false;
  filterHandleToggleOpen: boolean = false;
  serviceHandleToggleOpen: boolean = false;
  controlPosition: any = 'Right';
  controlDPosition: any = 'Left';
  startDate: any = new Date();
  endDate: any = new Date();
  sortItem: any = 'startdate';
  searchLayout: any = "";
  searchGroup: any = "";
  filterLayoutKey: any = ['code', 'compartmentName', 'componentName', 'groupName', 'layoutName', 'statusName','notificationNo','materialNo','surveyNo'];
  filterGroupKey: any = ['name'];
  currentActivityList: any = [];
  activitySelectedList: any = [];
  activityAll: any = true;
  activeShipList: any;
  parentCatListIdx: any;
  shipClassList: any = [];
  filterObjectKeys: any = ['layoutName'];
  filterGroupObjectKeys: any = [];
  defaultRangeDate = {
    "drawName": "Layout",
    "group": "Group",
    "status": "Status",
    "game": "Game"
  }
  sidepanelLayoutObject = [];
  sidepanelGroupObject = [];
  activeLayoutIndex: any;
  activeGroupIndex: any;
  isFilterAll: boolean = true;
  sidepanelLayoutData: any = [];
  sidepanelGroupData: any;
  hullAllStatus = 'solid';
  bulkheadsAllStatus = 'solid';
  sectionsAllStatus = 'solid';
  statusMenu = [
    { value: '#FF0000', name: 'BLOCKED' },
    { value: '#FFBF00', name: 'INPROGRESS' },
    { value: '#00FF00', name: 'COMPLETED' },
  ]
  statusFilter = []
  groupItems: any = ['Layout', 'Group', 'Stauts'];
  sortObjectKeys: any = ['code', 'compartmentName', 'componentName', 'groupName', 'layoutName', 'statusName'];
  sortlayoutItem: any = 'compartmentName';
  activitySelectStatus = true;
  activitySelectGroupAll = true;
  activitylayoutstaus = true;
  reportScreenList: any = [];
  showStatusPanelOpen: any = true;
  showGamePanel: any = false;
  shipStatusHandleToggleOpen: boolean = false;
  shipGameHandleToggleOpen: boolean = false;
  sidepanelStatusObject = [];
  sidepanelStatusData: any;
  filterStatusKey: any = ['name'];
  sortStatusItem: any = 'name';
  searchStatus: any = "";
  constructor(private domSanitizer: DomSanitizer, private khaConfig: KHASystemService, private cdRef: ChangeDetectorRef, private ctrlServe: ControllerService, private translate: TranslateService, private language: LanguageService, private CommunicationServ: CommunicationService, private datepipe: DatePipe, private configService: ConfigService) {
    this.translate.addLangs(['en', 'fr']);
    this.translate.setDefaultLang('en');
    this.translate.use('en');
    this.comps = this.ctrlServe.comps;
  }

  /* * * * *
  * method for communicate event instance with data to access all components
  * * * * * */
  broadcastInfo(data: any) {
    this.CommunicationServ.getInstance().next(data);
  }

  getCompartments() {
    let dir = compartments['default'];
    let arr = Object.keys(dir);
    // this.findNewList(arr);
    this.compartmentList = [];
    arr.forEach((item) => {
      this.compartmentList.push({ name: dir[item], code: item, selected: false, visiable: false });
    })
    return this.compartmentList;
  }
  findNewList(e) {
    var newListData = [];
    let newList = ["01DA", "01DB0", "01DC0", "01DY1", "01DY3", "01DZ0", "01DZ2", "01EA", "01EB", "01FZ1", "01FZ2", "01GZ0", "01GZ1", "01JA1", "01JA2", "01JZ1", "01JZ2", "02EA", "02FZ", "1DA", "1DA2", "1DB", "1DC0", "1DC1", "1DC2", "1DX2", "1DY1", "1DY2", "1DY3", "1DZ0", "1DZ1", "1DZ2", "1EA0", "1EA1", "1EA3", "1EA5", "1EB0", "1EZ", "1FA", "1FZ0", "1FZ2", "1GA", "1GZ1", "1HA1", "1HA2", "1JA0", "1JA1", "1JA2", "1JA3", "1JZ1", "1JZ2", "2AA", "2AZ1", "2AZ2", "2BA", "2BZ0", "2BZ2", "2CA0", "2CA1", "2CA2", "2CB0", "2CB2", "2CY0", "2CY2", "2CY4", "2CZ", "2DA", "2DB2", "2DY2", "2DY4", "2DZ0", "2DZ2", "2DZ4", "2EA0", "2EA1", "2EA2", "2EA4", "2EB1", "2EZ2", "2FA0", "2FA1", "2FA2", "2FB0", "2FB1", "2FB2", "2FC1", "2FC2", "2FX1", "2FY1", "2FY2", "2FZ0", "2FZ1", "2FZ2", "2FZ3", "2FZ4", "2GA1", "2GA2", "2GA4", "2GB1", "2GB2", "2GZ1", "2GZ2", "2GZ3", "2GZ5", "2HA1", "2HA2", "2HA3", "2HZ0", "2HZ1", "2HZ2", "2JA0", "2JA1", "2JA2", "2JA3", "2JA4", "2JB0", "2JB2", "2JZ0", "2JZ1", "2JZ2", "2JZ3", "2KA0", "2KA1", "2KA2", "2KA4", "2KB0", "2KB1", "2KB2", "2KY1", "2KZ0", "2KZ1", "2KZ2", "2KZ3", "2LA0", "2LA1", "2LA2", "2LB1", "2LB2", "2LY0", "2LY1", "2LZ0", "2LZ1", "2LZ2", "2LZ3", "2LZ4", "2MA0", "2MA1", "2MA2", "2MZ0", "2MZ1", "2MZ2", "3BZ", "3CA", "3CB2", "3CZ0", "3CZ2", "3DA0", "3DA2", "3DY0", "3DZ0", "3DZ2", "3EA0", "3EA1", "3EA2", "3EY1", "3EY2", "3EZ1", "3FA1", "3FA2", "3FA3", "3FA4", "3FB2", "3FC2", "3FY2", "3FZ1", "3FZ2", "3FZ4", "3GA1", "3GA2", "3GA4", "3GB2", "3GB4", "3GZ0", "3GZ2", "3HA1", "3HA2", "3HB1", "3HZ0", "3HZ1", "3HZ2", "3HZ3", "3JA0", "3JA1", "3JA2", "3JA3", "3JA4", "3JZ0", "3JZ1", "3JZ2", "3KA0", "3KA1", "3KA2", "3KA4", "3KZ0", "3KZ2", "3LA0", "3LA1", "3LA2", "3LA4", "3LZ0", "3MA0", "3MA1", "3MA2", "3MA4", "3MZ0", "3MZ2", "4BZ", "4CA", "4CB2", "4CZ", "4DA", "4DB0", "4DC1", "4DC2", "4DY2", "4DZ0", "4DZ1", "4DZ2", "4JA0", "4JA1", "4JA2", "4JA4", "4JB2", "4JZ0", "4JZ2", "4KA0", "4KA1", "4KA2", "4KA4", "4KB2", "4KZ", "4L", "4LA0", "5DA1", "5DA2", "5DZ0", "5E-CASING", "5E", "5H-CASING", "5H", "5JA0", "6CB0", "6DA0", "6F-INTAKES", "6F-UPTAKES", "6F", "6G-CASING", "6G", "MAA", "MAZ", "ZA-C", "ZD", "ZE-G", "ZH-J", "ZK-M"];
    newList.forEach(element => {
      let idx = e.findIndex(ele => ele == element);
      if (idx == -1) {
        newListData.push(element)
      }
    });
    console.log("newList", newListData);
  }
  updateComprtmentList() {
    let deckFliter = [];
    if (this.selectedDeck.indexOf('0') > -1) {
      deckFliter = this.shipComp['compList'].filter(element => element.code.substring(0, 2).toLowerCase() == this.selectedDeck.toLowerCase());
    } else {
      deckFliter = this.shipComp['compList'].filter(element => element.code.substring(0, 1).toLowerCase() == this.selectedDeck.toLowerCase());
    }
    this.compartmentDeckList = deckFliter;
    this.compartmentList = deckFliter;
  }

  onChangeLanguage(langName) {
    if (langName == 'English') {
      this.language.changeLanguage('fr');
      this.translate.use('fr');
      this.languageSelected = 'French';
    }
    if (langName == 'French') {
      this.language.changeLanguage('en');
      this.translate.use('en');
      this.languageSelected = 'English';
    }
  }
  quizPanelOpen: any = false;
  quizHandleToggleOpen: any = false;
  quizList: any = [];
  reportTableList: any;
  ngOnInit() {
    this.broadcastSubs = this.CommunicationServ.getInstance()
      .subscribe((data: any) => {
        if (data.src == "slmsSidepanel") {

          if (data.event == "compartmentLoad") {
            this.loadComparmentList.push(data.data)
            var selectedlistdata = JSON.stringify(this.selectedDeck);
            var selectedlistdataList = JSON.parse(selectedlistdata)
            this.loadComparmentList.forEach(data => {
              var idx = this.selectedDeck.findIndex(eleme => eleme == data.code.substring(0, 1).toLowerCase())
              if (idx == -1) {
                selectedlistdataList.push(data.code.substring(0, 1).toLowerCase())
              }
            })
            this.onChangeDeck(selectedlistdataList)
            console.log('selected Deck', selectedlistdataList)
            this.loadCompartment(data.data)
          }
          if (data.event == "clearLoadCompartment") {
            this.clearCompartmentList(data.data);
            var selectedlistdata = JSON.stringify(this.selectedDeck);
            var selectedlistdataList = JSON.parse(selectedlistdata)
            this.selectedDeck.forEach(data => {
              var filterData = this.loadComparmentList.filter(eleme => data == eleme.code.substring(0, 1).toLowerCase())
              if (filterData.length == 1) {
                if (filterData[0].code.substring(0, 1).toLowerCase() != '2') {
                  var idx = selectedlistdataList.findIndex(ele => ele == filterData[0].code.substring(0, 1).toLowerCase())
                  selectedlistdataList.splice(idx, 1)
                }
              }
            })
            this.onChangeDeck(selectedlistdataList)
            var idxList = this.loadComparmentList.findIndex(ele => ele.code == data.data.code)
            this.loadComparmentList.splice(idxList, 1);
          }
          if (data.event == "notesLoading") {
            if (data.data == true) {
            this.tagFlagCheck();
            }
          }
        }
        if (data.src === "khaservice") {
          if (data.event === 'update-compartments') {
            this.shipComp['compList'] = data['data'];
            this.ctrlServe.shipComp['compList'] = this.shipComp['compList'];
            this.updateComprtmentList();
            this.sortCompartment('name');
          }
          if (data.event == "slmsSidePanel") {
            if (data.data) {
              let compList = Object.keys(data.data);
              this.activeCompartmentLoad(compList);
            }
          }
          if (data.event == "updateActiveCard") {
            if(!this.layoutTagState){
              if (data.data) {
                this.activeCard = data.data;
              }
            }
         
          }
        }
        if (data.src === "sidepanel") {
          if (data.event == "scoreBoard") {
            this.quizPanelOpen = true;
            this.quizHandleToggleOpen = true;
            this.shipReportHandleToggleOpen = false;
            this.shipGroupHandleToggleOpen = false;
            this.shipHandleToggleOpen= false;
            this.slmsHandleToggleOpen=false;
            this.shipStatusHandleToggleOpen = false;
            // this.showReportPanelOpen=false;
            this.quizList = data['data'];
          }
          if (data.event === 'updateSettigns') {
            // var updateSettigns = data['data'];
            // if (updateSettigns == true) {
            //   this.slmsHandleToggleOpen = false;
            // } else {
            //   this.slmsHandleToggleOpen = true;
            // }
          }
          if (data.event == 'deckValue') {
            this.onChangeDeck(data.data)
          }
          if (data.event == 'deleteCompartmentNotes') {
            this.selectedNotesId = data.data;
            this.layoutId  = data.key;
            this.markerName = data.key1;
            this.deleteNotes()
          }
        }
        if (data.src === "kys") {
          if (data.event === 'updateGroup') {
            this.sidepanelGroupObject = data.data;
            this.sidepanelGroupData = this.sidepanelGroupObject;
            console.log("updateGroup", data.data);
            if (this.activeGroupIndex && this.sidepanelGroupObject) {
              let idx = this.sidepanelGroupData.findIndex(e => e['_id'] == this.activeGroupIndex)
              if (idx > -1) {
                this.broadcastInfo({ src: 'sidepanel', event: 'groupList', data: this.sidepanelGroupObject[idx]['groupList'], key: "" });
              }
            }
          }
          if (data.event === 'updateStatus') {
            this.sidepanelStatusObject = data.data;
            this.sidepanelStatusData = this.sidepanelStatusObject;
            console.log("updateStatus", data.data);
          }
          if (data.event === 'updateStatusData') {
            var sidepanelStatusObject = data.data;
            if (sidepanelStatusObject == 'reConstructTagJson') {
              this.reConstructTagJson();
            }
          }
        }
        if (data.src === "material") {
          if (data.event == "quiz-sidepanel-hide") {
            this.appMode = data['data'];
            // this.slmsPanelOpen = false;
            this.showPanelOpen = false;
            this.showGroupPanelOpen = false;
            this.showStatusPanelOpen = false;
            this.showReportPanelOpen = false;
            // this.showHideStruct('Hull','none');
            // this.showHideStruct('Bulkheads','none');
            // this.showHideStruct('Sections','none');
            // this.showHideStruct('OtherDecks','none');
            // this.onChangeDeck(['2','3','4','5'])
          }
          if (data.event == "layoutTagGroup") {
            let tagList = data.data;
            if (tagList) {
              let idx = this.sidepanelLayoutData.findIndex(e => e['_id'] == tagList['_id']);
              if (idx > -1) {
                this.sidepanelLayoutData[idx]['tagPoints'] = tagList['tagPoints'];
                this.reConstructTagJson();
                this.sortByLayoutlist(this.sortlayoutItem);
                if (this.searchLayout) {
                  this.searchData();
                }
              }
            }
          }
          if (data.event == "updateLoadGroup") {
            if (this.activeGroupIndex) {
              let groupId = data.data;
              let idx = this.sidepanelGroupData.findIndex(e => e['_id'] == this.activeGroupIndex)
              if (idx > -1) {
                // this.groupDeckSelected(this.sidepanelGroupData[idx]['groupList']);
                this.khaConfig.updateStatusGroup(groupId.code, groupId.id)
              }
            }
          }
          if (data.event === 'updateLayoutData') {
            let layoutData = data['data'];
            if (layoutData.length > 0) {
              this.sidepanelLayoutObject = layoutData;
              this.sidepanelLayoutData = layoutData;
              this.reConstructTagJson();
              this.sortByLayoutlist(this.sortlayoutItem);
              if (this.searchLayout) {
                this.searchData();
              }
              var listData = this.sidepanelLayoutData[0];
              // this.getFilterKey(listData);
            }
          }
          if (data.event === 'clearLayout') {
            // this.layoutTag(this.activeLayoutIndex)
            // console.log("239","reset")
            // this.resetDeck();
            delete this.activeLayoutId;
            delete this.activeLayoutIndex;
            delete this.activeCard;
            this.currentComp.forEach((e) => {
              setTimeout(() => {
                this.clearCompartment(e);

              }, 300)
            });
          }
          if (data.event == 'resetDeck') {
            // console.log("250","reset")
            // this.resetDeck();
            // delete this.activeGroupIndex;

            // this.currentComp.forEach((e) => {
            //   setTimeout(() => {
            //     this.clearCompartment(e);

            //   }, 10)
            // });
            // this.onClearDeck();
          }
          if (data.event === 'selectedLayoutIndex') {
            let idx = data['data'];
            // let inx= this.sidepanelLayoutData.findIndex(e=> e['_id']==idx['_id']);
            // if(inx>-1){
            // var event;
            // this.activeLayout(event, inx, this.sidepanelLayoutData[inx]);
            this.broadcastInfo({ src: 'controlpanel', event: 'load-update-compartment', data: this.sidepanelLayoutData[idx], key: true });
            // }
            if (this.sidepanelLayoutData[idx]['tagPoints'].length > 0) {
              this.layoutTagState = true;
            }
            this.activeLayoutId =this.sidepanelLayoutData[idx]['_id'];
            this.activeLayoutIndex = idx;


          }
          if (data.event == "layoutTagClose") {
            let layoutData = data['data'];
            layoutData.tagShowState = false;
            this.khaConfig.showLayoutTag(layoutData, false);
            if (this.khaConfig.layoutTagList.length == 1) {
              this.layoutTagState = false;
            }
            // delete this.activeCard;
          }
          if (data.event == "layoutTagCloseActive") {
            // let layoutData = JSON.parse(this.selectedLayoutList)
            // this.khaConfig.showLayoutTag(this.sidepanelGroupTagpoint[this.activeCard], false);
            delete this.activeCard;
           
          }
          if (data.event == "layoutTagOpen") {
            let layoutData = data['data'];
            let status = data['status']
            this.khaConfig.showLayoutTag(layoutData, status);
            if (this.khaConfig.layoutTagList.length > 0) {
              this.layoutTagState = true;
            } else {
              this.layoutTagState = false;
            }
          }
          if (data.event == 'screenshot') {
            this.reportScreenList = data['data'];
            this.reportTableList = data['tableData']
            console.log("reportScreenList", this.reportScreenList, this.reportTableList);
          }
          if (data.event == 'deckToggle') {
            this.showHideStruct('Hull', 'none');
            this.showHideStruct('Bulkheads', 'none');
            this.showHideStruct('Sections', 'none');
            this.showHideStruct('OtherDecks', 'none');
          }
          if (data.event == 'selectedDeckQuiz') {
            var deckData = [data['data']];
            this.searchDeckSelection(deckData);
          }
          if (data.event == 'clearLayoutList') {
            this.compartmentList.some(ele => ele.visiable == false && ele.selected == false);
            this.compartmentList.forEach(ele => {
              if (ele.visiable == true) {
                ele.visiable = false;
                ele.selected == false;
                this.clearCompartmentList(ele);
              }
            });
            // this.compartmentList.some(ele => ele.selected == false);
          }
        }
        if (data.src === "main") {
          if (data.event == "deleteLayoutData") {
            this.deleteLayoutData();
          }
          if (data.event == "deleteGroupData") {
            this.deleteGroupData();
          }
          if (data.event == "deleteStatusData") {
            this.deleteStatusData();
          }
          if (data.event == "layoutNotesDelete") {
            //this.deleteGroupData();
            this.layoutId = data.data;
            this.selectedNotesId = data.notesId;
            this.deleteNotes()
            //this.broadcastInfo('')
          }
        }
      })
  }
  quizToggleOpenHanddle() {
    this.quizHandleToggleOpen = !this.quizHandleToggleOpen;
  }
  getScore() {
    let arr = this.quizList.filter(el => el.result === 1);
    let val = arr.length * 100 / this.quizList.length;
    return Math.round(val);
  }

  getCorrectAnsLen() {
    let arr = this.quizList.filter(el => el.result === 1);
    return arr.length;
  }

  getWrongAnsLen() {
    let arr = this.quizList.filter(el => el.result === 0);
    return arr.length;
  }
  getImageURL(e) {
    return this.domSanitizer.bypassSecurityTrustUrl(e)
  }
  removeScreenList(i) {
    if (this.reportScreenList.length > 0 && this.reportScreenList[i]) {
      console.log("removeScreenList", this.reportScreenList[i]);
      if (this.reportScreenList[i]['id']) {
        let idx = this.reportTableList.findIndex(e => e.layoutId == this.reportScreenList[i]['id']);
        if (idx > -1) {
          this.reportTableList.splice(idx, 1);
          this.broadcastInfo({ src: 'sidepanel', event: 'update-report-table', data: this.reportTableList });
        }
      }

      this.reportScreenList.splice(i, 1);
      this.broadcastInfo({ src: 'sidepanel', event: 'update-screenshot', data: this.reportScreenList });
    }

  }

  // reportDownload() {
  //   if (this.reportScreenList.length > 0) {
  //     var pdf = new jsPDF('l', 'px', [900, 440]);
  //     // pdf.addPage();
  //     this.reportScreenList.forEach((element, index) => {
  //       if (index > 0) {
  //         pdf.addPage();
  //       }
  //       // var width = pdf.internal.pageSize.getWidth();
  //       // var height = pdf.internal.pageSize.getHeight();
  //       pdf.setPage(index + 1);
  //       pdf.addImage(element, 'JPEG', 0, 0, 0, 0);


  //     });
  //     pdf.save('Report_' + Date.now() + '.pdf');
  //   }
  // }
  pageIdx: any = 0;
  reportDownload() {
    this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: true, process_txt: "Processing...", selectedDemo: "", event: 'showLoading' } });
    if (this.reportTableList.length > 0) {
      var position = 0;
      var pdf = new jsPDF('l', 'px', [770, 360]);
      this.reportTableList.forEach((ele, index) => {
        if (this.reportScreenList.length > 0) {
          var elem = document.getElementById("report_tbl_" + ele.layoutId);
          //   // console.log("reportDownload",elem)
          html2canvas(elem, { scale: 1, backgroundColor: '#ffffff' }).then(canvas => {
            if (index > 0) {
              pdf.addPage();
            }
            position = position + 1;
            pdf.setPage(position + 1);
            const imgDataURL = canvas.toDataURL('image/PNG', 1.0);
            pdf.addImage(imgDataURL, 'PNG', 0, 0, 0, 0);
            var width = pdf.internal.pageSize.getWidth();
            var height = pdf.internal.pageSize.getHeight();
            var croppingYPosition = 630;
            var count = (canvas.height) / 630;

            for (var i = 1; i < count; i++) {
              // this.pdf.addPage();
              position = position + 1;
              var sourceX = 0;
              var sourceY = croppingYPosition;
              var sourceWidth = canvas.width;
              var sourceHeight = 630;
              var destWidth = sourceWidth;
              var destHeight = sourceHeight;
              var destX = 0;
              var destY = 0;
              // var canvas1 = document.createElement('canvas');
              // canvas1.setAttribute('height', destHeight.toString());
              // canvas1.setAttribute('width', destWidth.toString());                         
              // var ctx = canvas1.getContext("2d");
              window.onePageCanvas = document.createElement("canvas");
              window.onePageCanvas.setAttribute('width', destWidth.toString());
              window.onePageCanvas.setAttribute('height', destHeight.toString());
              var ctx = window.onePageCanvas.getContext('2d');

              // ctx.scale(2, 2);
              ctx.fillStyle = 'white';
              ctx.fillRect(0, 0, destWidth.toString(), destHeight.toString());
              ctx.drawImage(canvas, sourceX, sourceY, sourceWidth, sourceHeight, destX, destY, destWidth, destHeight);
              var canvasDataURL = window.onePageCanvas.toDataURL("image/png", 1.0);
              // i++;
              pdf.addPage();
              pdf.setPage(position);
              pdf.addImage(canvasDataURL, "PNG", 0, 0, 0, 0);
              if (sourceY > canvas.height) {
                break;
              }

              croppingYPosition += destHeight;
            }
            // var d = new Date().toISOString().slice(0, 19).replace(/-/g, "");
            // filename = 'report_' + d + '.pdf';
            // doc.save(filename);
            //////////////
            this.reportScreenList.forEach((element, ind) => {
              if (element.id) {
                if (element.id == ele.layoutId) {
                  // if (ind > 0) {
                  pdf.addPage();
                  // }
                  // var width = pdf.internal.pageSize.getWidth();
                  // var height = pdf.internal.pageSize.getHeight();
                  position = position + 1;
                  pdf.setPage(position);
                  pdf.addImage(element.file, 'JPEG', 0, 0, 0, 0);
                }
              }
            });

            if ((this.reportTableList.length - 1) == index) {
              this.reportScreenList.forEach((element, ind) => {
                if (element.id == '') {
                  // if (ind > 0&&index>0) {
                  pdf.addPage();
                  // }
                  // var width = pdf.internal.pageSize.getWidth();
                  // var height = pdf.internal.pageSize.getHeight();
                  position = position + 1;
                  pdf.setPage(position);
                  pdf.addImage(element.file, 'JPEG', 0, 0, 0, 0);
                }
              });
              pdf.save('Report_' + Date.now() + '.pdf');
              this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: false, process_txt: "Processing...", selectedDemo: "", event: 'showLoading' } });
            }
          });


          //   var elem = document.getElementById("report_tbl_"+ele.layoutId);
          //   // console.log("reportDownload",elem)
          //   html2canvas(elem, { scale: 1, backgroundColor: '#ffffff' }).then(canvas => {

          //   //   const contentDataURL = canvas.toDataURL('image/png')  
          //  // A4 size page of PDF  
          //  let file =canvas// ele.file;
          //     if(index>0){
          //       pdf.addPage();
          //       position= position +1;
          //     }
          //     // pdf.addPage();
          //     if(file.height>600){
          //       console.log
          //       let height = Math.round(file.height/100);
          //       let width =  Math.round(Math.round(file.height/500)/2);
          //       pdf.internal.pageSize.width = 770+width;
          //       pdf.internal.pageSize.height = 370+height;
          //       console.log("pdf", pdf.internal.pageSize.height,height,width)
          //     }

          //     // 
          //     pdf.setPage(position);
          //     console.log("htmlFile",file.width,file.height)
          //     pdf.addImage(file.toDataURL('image/png'), 'PNG', 0, 0, 0, 0)
          //     //   pdf = new jsPDF('l', 'px', [900, 440]);
          //     // pdf.addPage();
          //     pdf.internal.pageSize.height=770;
          //     pdf.internal.pageSize.height=370;
          //      this.reportScreenList.forEach((element, ind) => {
          //       if(element.id){
          //         if(element.id==ele.layoutId){
          //           // if (ind > 0) {
          //             pdf.addPage();
          //           // }
          //           // var width = pdf.internal.pageSize.getWidth();
          //           // var height = pdf.internal.pageSize.getHeight();
          //           position= position +1;
          //           pdf.setPage(position );
          //           pdf.addImage(element.file, 'JPEG', 0, 0, 0, 0);
          //          }
          //         }          
          //       });
          //      this.reportScreenList.forEach((element, ind) => {
          //       if(element.id==''){
          //         // if (ind > 0&&index>0) {
          //           pdf.addPage();
          //         // }
          //         // var width = pdf.internal.pageSize.getWidth();
          //         // var height = pdf.internal.pageSize.getHeight();
          //         position= position +1;
          //         pdf.setPage(position );
          //         pdf.addImage(element.file, 'JPEG', 0, 0, 0, 0);
          //       }
          //      });
          //  if((this.reportTableList.length-1)==index){
          //   pdf.save('Report_' + Date.now() + '.pdf');
          //   this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: false, process_txt: "Processing...", selectedDemo: "", event: 'showLoading' } });
          //  }

          //     })

        }
      });

    } else {
      if (this.reportScreenList.length > 0) {

        var pdf = new jsPDF('l', 'px', [770, 370]); // A4 size page of PDF  

        this.reportScreenList.forEach((element, index) => {
          if (index > 0) {
            pdf.addPage();
          }
          // var width = pdf.internal.pageSize.getWidth();
          // var height = pdf.internal.pageSize.getHeight();
          //  position= position +1;
          pdf.setPage(index + 1);
          pdf.addImage(element.file, 'JPEG', 0, 0, 0, 0);
        });
        pdf.save('Report_' + Date.now() + '.pdf');
        this.broadcastInfo({ src: 'loader', event: 'loaderState', data: { state: false, process_txt: "Processing...", selectedDemo: "", event: 'showLoading' } });
      }
    }
    // // if (this.reportScreenList.length > 0) {
    //   html2canvas(document.getElementById("report_tbl"), { scale: 1, backgroundColor: '#ffffff' }).then(canvas => {

    //   const contentDataURL = canvas.toDataURL('image/png')  
    //   var pdf = new jsPDF('l', 'px', [900, 440]); // A4 size page of PDF  
    //   var position = 1;  
    //   // pdf.addPage();
    //   pdf.setPage(position);
    //   pdf.addImage(contentDataURL, 'PNG', 0, 0, 0, 0)
    //   //   pdf = new jsPDF('l', 'px', [900, 440]);
    //   pdf.addPage();
    //    this.reportScreenList.forEach((element, index) => {
    //      if (index > 0) {
    //        pdf.addPage();
    //      }
    //      // var width = pdf.internal.pageSize.getWidth();
    //      // var height = pdf.internal.pageSize.getHeight();
    //      position= position +1;
    //      pdf.setPage(position );
    //      pdf.addImage(element.file, 'JPEG', 0, 0, 0, 0);
    //    });
    //    pdf.save('Report_' + Date.now() + '.pdf');
    //   })

    // }

  }
  reconstrucuLayoutData: any;
  reconstrucuLayoutDataList: any;
  groupJsonData: any;
  layoutJsonData: any;
  reConstructTagJson() {
    if (this.sidepanelLayoutData.length != 0) {
      this.sidepanelGroupTagpoint = [];
      this.layoutJson = [];
      this.groupJson = [];
      this.statusFilter = [];
      let tagList = {};
      this.sidepanelLayoutData.forEach((element, i) => {
        this.layoutJson.push({ 'layoutName': element.layoutName, 'layoutId': element._id, isChecked: true })
        element.tagPoints.forEach((tagpoint, idx) => {
          tagList = tagpoint
          var compartmentIdx = element.compartments.findIndex(obj => obj.code == tagpoint.code);
          var compoentsIdx = element.components.findIndex(obj => obj.name == tagpoint.partId);
          // tagList['tagShowState']=false;
          if (tagpoint.groupData) {
            tagList['groupName'] = tagpoint.groupData.name;
            tagList['groupColor'] = tagpoint.groupData.color;
           
          }
          // tagList['groupId'] = tagpoint.groupData._id;
          this.groupJson.push({ "groupName": tagpoint.groupName, "groupColor": tagpoint.groupColor, isChecked: true, 'layoutId': element._id })
          // console.log(this.groupJson)
          if (tagpoint.tagComments) {
            if (tagpoint.tagComments.startDate) {
              tagList['startDate'] = tagpoint.tagComments.startDate ? tagpoint.tagComments.startDate : '';
            } else {
              tagList['startDate'] = "";
            }
            // console.log('tagpoint.tagComments', tagpoint.tagComments.statusId, this.sidepanelStatusData);
            // this.sidepanelStatusData.forEach(ele => {
            //   if (ele._id == tagpoint.tagComments.statusId) {
            //     tagList['statusName'] = ele.name;
            //     tagList['statusColor'] = ele.value;
            //   }
            // });
            if (tagpoint.tagComments.statusId) {
                if (this.sidepanelStatusData) {
                  let filteredStatus = this.sidepanelStatusData.filter(m => m._id == tagpoint.tagComments.statusId);
                  var statusData = filteredStatus[0]
                if (statusData != undefined) {
                  tagList['statusName'] = statusData.name;
                  tagList['statusColor'] = statusData.value;
                }else{
                  tagList['statusName'] = '';
                  tagList['statusColor'] = '';
                }
                if (statusData == undefined) {
                  tagList['statusName'] = '';
                  tagList['statusColor'] = '';
                }
              }else{
                // this.reConstructTagJson();
              }
            }
            if (tagpoint.tagComments) {
              tagList['notificationNo'] = tagpoint.tagComments.notificationNo?tagpoint.tagComments.notificationNo:'';
              tagList['materialNo'] = tagpoint.tagComments.materialNo?tagpoint.tagComments.materialNo:'';
              tagList['surveyNo'] = tagpoint.tagComments.surveyNo?tagpoint.tagComments.surveyNo:'';
            }
          }

          this.statusFilter.push({ "statusName": tagList['statusName'], "statusColor": tagList['statusColor'], isChecked: true, 'layoutId': element._id })
          tagList['layoutId'] = element._id;
          tagList['layoutName'] = element.layoutName;
          tagList['componentName'] = tagpoint['name'];
          if (compartmentIdx != -1) {
            tagList['compartmentName'] = element.compartments[compartmentIdx].name;
          } if (compoentsIdx != -1) {
            tagList['compoentsPosition'] = element.components[compoentsIdx].position;
          }
          this.sidepanelGroupTagpoint.push(tagList);
        })

      });
      this.reconstrucuLayoutDataList = this.sidepanelGroupTagpoint;
      this.reconstrucuLayoutData = this.sidepanelGroupTagpoint;
      this.filterLayoutJson = this.layoutJson;
      this.layoutJsonData = this.layoutJson;
      this.broadcastInfo({ src: 'sidepanel', event: 'reconstruct', layout: this.reconstrucuLayoutData,notes:this.sidepanelGroupTagpoint });
      this.broadcastInfo({ src: 'sidepanel', event: 'report-table', data: this.reconstrucuLayoutData });
      const ids = this.groupJson.map(o => o.groupName);
      this.groupJson = this.groupJson.filter(({ groupName }, index) => !ids.includes(groupName, index + 1));
      this.groupJsonData = this.groupJson
      const statusids = this.statusFilter.map(o => o.statusName);
      this.statusFilter = this.statusFilter.filter(({ statusName }, index) => !statusids.includes(statusName, index + 1));
      console.log("reconstruct", this.sidepanelGroupTagpoint, this.sidepanelLayoutData);
      console.log("statusFilter", this.statusFilter);
    } else {
      this.sidepanelGroupTagpoint = [];
      this.layoutJson = [];
      this.groupJson = [];
    }

  }
  resetDeck() {
    // this.changeMatrixHullAll('solid');
    //     this.changeMatrixbulkheadsAll('solid');
    //     this.changeMatrixSectionsAll('solid');
    this.showHideStruct('Hull', 'solid');
    this.showHideStruct('Bulkheads', 'solid');
    this.showHideStruct('Sections', 'solid');
    this.showHideStruct('OtherDecks', 'clear');
  }

  gameManager
  ngAfterViewInit() {
    if(this.appGameModeContrl){
      this.gameManager = new GameService(this.khaConfig.datauxview, this.CommunicationServ, this.khaConfig);
    }
    // 
    this.shipComp['compList'] = this.getCompartments();
    this.ctrlServe.shipComp['compList'] = this.shipComp['compList'];
    this.compartmentDeckList = this.getCompartments();
    console.log("getCompartments", this.compartmentDeckList);
    if(this.compToggle){
      if(this.compToggle['tab']=='kha'){
        this.onTabChanged({ index: 0 });
      }
      if(this.compToggle['tab']=='presets'){
        this.onTabChanged({ index: 2 });
        if(this.compToggle['selectMenu']!=''){
          setTimeout(() => {
            this.processSystem(this.compToggle['selectMenu'])
          }, 1000);
          
        }
      }
      if(this.compToggle['tab']=='ladders'){
        this.onTabChanged({ index: 2 });
        if(this.compToggle['selectMenu']!=''){
          setTimeout(() => {
            this.processSystem(this.compToggle['selectMenu']);
            this.showHideStruct('Hull','none');
            this.showHideStruct('Bulkheads','none');
            this.showHideStruct('Sections','none');
            this.showHideStruct('OtherDecks','none');
            this.broadcastInfo({ src: 'sidepanel', event: 'show-exit-work', data: true })
          }, 1000);
          
        }
      }
    }

    this.cdRef.detectChanges();
    this.onClearDeck();
  }

  getPanelwidth(e) {
    let elem = document.getElementById(e);
    return 'translateX(' + elem.offsetWidth + 'px)';
  }

  slmsToggleOpenHandle() {
    this.slmsHandleToggleOpen = !this.slmsHandleToggleOpen;
  }

  showHideStruct(label, state) {
    console.log(label, state);
    if (label.toLowerCase() == 'hull') {
      this.structHull = state;
    } else if (label.toLowerCase() == 'decks') {
      this.structDecks = state;
    } else if (label.toLowerCase() == 'bulkheads') {
      this.structBulkheads = state;
    } else if (label.toLowerCase() == 'sections') {
      this.structSections = state;
    } else if (label.toLowerCase() == 'otherdecks') {
      this.structOtherDecks = state;
    }
    let data = state === 'clear' ? 'transparent' : state;
    data = state === 'none' ? 'hide' : data;
    if (label.toLowerCase() === 'otherdecks') {
      this.broadcastInfo({ src: 'sidepanel', event: 'toggle-otherdecks-state', data, key: label });
    } else {
      this.broadcastInfo({ src: 'sidepanel', event: 'toggle-struct-state', data, key: label });
    }
  }


  onChangeDeck(value) {
    this.selectedDeck = value;
    //   if(this.selectedDeck.length != 0){
    //     var selectedDeckIdx = this.selectedDeck.findIndex(obj => obj == value)
    //     if(selectedDeckIdx == -1){
    //       this.selectedDeck.push(value)
    //     } else{
    //       this.selectedDeck.splice(selectedDeckIdx ,1)
    //     }
    //  } else {
    //    this.selectedDeck.push(value);
    //  }
    //this.selectedDeck = value;
    var deckFliter = [];
    let deckMultiple = []
    this.selectedDeck.forEach(ele => {
      if (ele.indexOf('0') > -1) {
        deckFliter = this.shipComp['compList'].filter(element => element.code.substring(0, 2).toLowerCase() == ele.toLowerCase());
        if (ele.toLowerCase() == "01") {
          let addComp = []
          addComp = this.shipComp['compList'].filter(element => element.code.includes("ZD") || element.code.includes("ZH-J"));
          console.log("01", addComp);
          deckFliter = deckFliter.concat(addComp);
        }
      } else {
        deckFliter = this.shipComp['compList'].filter(element => element.code.substring(0, 1).toLowerCase() == ele.toLowerCase());
        if (ele.toLowerCase() == "1") {
          let addComp = []
          addComp = this.shipComp['compList'].filter(element => element.code.includes("ZA-C") || element.code.includes("ZE-G") || element.code.includes("ZK-M"));
          console.log("01", addComp);
          deckFliter = deckFliter.concat(addComp);
        }
      }
      if (deckMultiple.length > 0) {
        deckMultiple = deckMultiple.concat(deckFliter)
      } else {
        deckMultiple = deckFliter;
      }
    });
    // var unselectedList = this.khaConfig.matrixDataList.filter( function(n) { return !this.has(n.name) }, new Set(this.selectedDeck) );
    // this.khaConfig.matrixDataList.forEach(element => {
    //   this.selectedDeck.forEach(ele => {
    //     if (element.name == ele) {
    //       element.visible = true;
    //     }
    //   });
    //   unselectedList.forEach(elemList =>{
    //     if(element.name == elemList.name && element.name != "otherDeck"){
    //       element.hull = this.hullAllStatus;
    //       element.bulkheads = this.bulkheadsAllStatus;
    //       element.sections = this.sectionsAllStatus;
    //     }else if(element.name == "otherDeck") {
    //       element.hull = "transparent";
    //       this.showHideStruct('otherDecks',"transparent")
    //     }
    //   })

    // });

    console.log(deckMultiple)
    this.compartmentDeckList = deckMultiple;
    this.compartmentList = deckMultiple;
    this.search = "";
    this.broadcastInfo({ src: 'sidepanel', event: 'filter-deck', data: this.selectedDeck, key: "" });
    this.deckSelectionCheckClear();
  }

  changeDeck(value) {
    this.selectedDeck = value;
    var deckFliter = [];
    let deckMultiple = []
    this.selectedDeck.forEach(ele => {
      if (ele.indexOf('0') > -1) {
        deckFliter = this.shipComp['compList'].filter(element => element.code.substring(0, 2).toLowerCase() == ele.toLowerCase());
        if (ele.toLowerCase() == "01") {
          let addComp = []
          addComp = this.shipComp['compList'].filter(element => element.code.includes("ZD") || element.code.includes("ZH-J"));
          console.log("01", addComp);
          deckFliter = deckFliter.concat(addComp);
        }
      } else {
        deckFliter = this.shipComp['compList'].filter(element => element.code.substring(0, 1).toLowerCase() == ele.toLowerCase());
        if (ele.toLowerCase() == "1") {
          let addComp = []
          addComp = this.shipComp['compList'].filter(element => element.code.includes("ZA-C") || element.code.includes("ZE-G") || element.code.includes("ZK-M"));
          console.log("01", addComp);
          deckFliter = deckFliter.concat(addComp);
        }
      }
      if (deckMultiple.length > 0) {
        deckMultiple = deckMultiple.concat(deckFliter)
      } else {
        deckMultiple = deckFliter;
      }
    });
    console.log(deckMultiple)
    this.compartmentDeckList = deckMultiple;
    this.compartmentList = deckMultiple;
    this.broadcastInfo({ src: 'sidepanel', event: 'filter-deck', data: value, key: "" });
  }

  onClearDeck() {
    this.selectedDeck = ["2"];
    let deckFliter = [];
    let deckMultiple = []
    this.selectedDeck.forEach(ele => {
      if (ele.indexOf('0') > -1) {
        deckFliter = this.shipComp['compList'].filter(element => element.code.substring(0, 2).toLowerCase() == ele.toLowerCase());
      } else {
        deckFliter = this.shipComp['compList'].filter(element => element.code.substring(0, 1).toLowerCase() == ele.toLowerCase());
      }
      if (deckMultiple.length > 0) {
        deckMultiple = deckMultiple.concat(deckFliter)
      } else {
        deckMultiple = deckFliter;
      }
    });
    console.log(deckMultiple)
    this.compartmentDeckList = deckMultiple;
    this.compartmentList = deckMultiple;
    this.search = "";
    if (this.search != '') {
      this.searchValue();
    }
    this.search = "";
    this.broadcastInfo({ src: 'sidepanel', event: 'filter-deck', data: this.selectedDeck, key: "" });
    this.deckSelectionCheckClear()
    // if (this.currentComp.length > 0) {
    //   this.currentComp.forEach((e) => {
    //     this.clearCompartment(e);
    //   })
    // }
    // if(this.khaConfig.matrixDataList){
    //   this.khaConfig.matrixDataList.forEach(element => {
    //     if(element.name !="otherDeck"){
    //       element.visible = false;
    //     }
    //     this.selectedDeck.forEach(ele => {
    //       if (element.name == ele) {
    //         element.visible = true;
    //       }
    //     });
    //   });
    // }  
  }
  deckSelectionCheckClear() {
    if (this.shipComp['compList'].length > 0) {
      this.shipComp['compList'].forEach(element => {
        if (element.selected) {
          let idx = this.compartmentList.findIndex(e => e.code == element.code);
          if (idx == -1) {
            this.clearCompartmentList(element);
          }
        }
      });
    }
  }
  shadowAdd(e) {
    this.shadowActive = e.checked
  }

  /* *
  * method for show/hide sub systems
  * */
  showFocusSubSystem(s) {
    var subSystemActiveList = this.ctrlServe.showSysComp
    var subSystemActive = subSystemActiveList[this.selectedKha];
    // delete this.khaConfig.layoutName;
    if (!subSystemActive) return;
    subSystemActive.forEach((item, index) => {
      if (item == s) {
        this.broadcastInfo({ src: 'controlpanel', event: 'focusSubSystem', data: 'true', key: s });
      }
    })
  }

  showHideSubSystem(e, s) {
    this.ctrlServe.selectedSysComp = [];
    this.ctrlServe.updateSysComps(s, e.checked);
    this.broadcastInfo({ src: 'controlpanel', event: 'showhidesubsystem', data: e.checked, key: s });
    this.checkSubSystemStatus();
  }

  checkSubSystemStatus() {
    let hideAll, hideSys, showAll;
    const idx = this.comps.findIndex(el => el.component.toLowerCase() === 'kha');
    this.comps[idx]["compList"].forEach(item => {
      if (item['key'] === this.selectedKha.split(" ").join("").toLowerCase()) {
        hideSys = item['systemList'].some(sys => sys['status'] == 'inactive');
        hideAll = item['systemList'].every(sys => sys['status'] == 'inactive');
        showAll = item['systemList'].every(sys => sys['status'] == 'active');
      }
    })
    this.showAllSystem = hideSys ? false : true;
    if (hideAll) {
      this.showAllSystems({ checked: false });
    }
    if (showAll) {
      setTimeout(() => {
        this.showAllSystems({ checked: true });
      }, 1000);
    }
  }
  // loadViewCompartment(s) {
  //   let show = true;
  //   this.shipComp['compList'].forEach(sys => {
  //     if (sys['code'] == s.code) {
  //       sys.selected = true;
  //       show = true;
  //       if (this.currentComp.length > 0) {
  //         let idx = this.currentComp.findIndex(e => e.code == s.code);
  //         if (idx == -1) {
  //           this.currentComp.push(s);
  //         }
  //       } else {
  //         this.currentComp.push(s);
  //       }
  //       // this.currentComp = show ? s : "";
  //     } else {
  //       // if (!this.slms_mode) {
  //       //   sys.selected = false;
  //       // }
  //     }
  //   });
  //   if (!this.slms_mode) {
  //     this.resetWallmode();
  //   }
  //   this.broadcastInfo({ src: 'controlpanel', event: 'loadcompartment', data: s, key: show });
  // }
  activeCompartmentLoad(list) {
    list.forEach(sys => {
      let idx = this.shipComp['compList'].findIndex(e => e.code == sys);
      if (idx > -1) {
        this.currentComp.push(this.shipComp['compList'][idx]);
        this.shipComp['compList'][idx].selected = true;
        this.shipComp['compList'][idx].visiable = true;
      }
    });
  }
  loadCompartment(s) {
    let show = true;
    let returnValue = false;
    this.shipComp['compList'].forEach(sys => {
      if (sys['code'] == s.code) {
        sys.selected = true;
        sys.visiable = true
        show = true;
        if (this.currentComp.length > 0) {
          let idx = this.currentComp.findIndex(e => e.code == s.code);
          if (idx == -1) {
            this.currentComp.push(s);
          }
          // else{
          //   console.log(s);
          //   returnValue=true;

          // }
        } else {
          this.currentComp.push(s);
        }
        // this.currentComp = show ? s : "";
      } else {
        // if (!this.slms_mode) {
        //   sys.selected = false;
        // }
      }
    });
    // if(returnValue){
    //   this.clearCompartment(s);
    //   return;
    // }
    if (!this.slms_mode) {
      this.resetWallmode();
    }
    this.broadcastInfo({ src: 'controlpanel', event: 'loadcompartment', data: s, key: show });
  }
  resetWallmode() {
    this.shipComp['compList'].forEach(sys => {
      if (sys['wallmode']) {
        sys.wallmode = !sys.wallmode;
      }
    });
  }
  isActiveComparment() {
    let showSelectedValue = this.compartmentList.some(ele => ele.visiable == true);
    return showSelectedValue
  }
  /* *
  * method for showHideCompartmentWall
  * */
  showHideCompartmentWall(sys) {
    if (this.currentComp.length > 0) {
      sys.wallmode = !sys.wallmode;
      this.broadcastInfo({ src: 'controlpanel', event: 'showhidecompartmentwall', data: !sys.wallmode, key: [sys.code] });
    }
  }

  clearCompartment(sys) {
    if (sys) {
      sys.selected = false;
      delete this.khaConfig.compartments_store[sys.code];
      if (this.currentComp.length > 0) {
        let idx = this.currentComp.findIndex(e => e.code == sys.code);
        if (idx > -1) {
          this.currentComp.splice(idx, 1);
        }
      }
      if (this.compartmentList.length > 0) {
        let idx = this.compartmentList.findIndex(e => e.code == sys.code);
        if (idx > -1) {
          this.compartmentList[idx]['selected'] = false;
          this.compartmentList[idx]['visiable'] = false;
        }
      }
      // console.log("clearCompartment ", this.currentComp);
      this.broadcastInfo({ src: 'sidepanel', event: 'clearCompartment', data: sys.code, key: "" });
    }
  }
  clearCompartmentList(sys) {
    var compState = true;
    if (this.khaConfig.layoutData) {
      if (this.khaConfig.layoutData['compartments']) {
        let idx = this.khaConfig.layoutData['compartments'].findIndex(e => e.code == sys.code);
        if (idx > -1) {
          compState = false;
        }
      }

    }
    if (this.khaConfig.groupList && this.khaConfig.groupMode) {
      let idx = this.khaConfig.groupList.findIndex(e => e.code == sys.code);
      if (idx > -1) {
        compState = false;
      }
    }
    if (compState) {
      if (sys) {
        delete this.khaConfig.compartments_store[sys.code];
        sys.selected = false;
        if (this.currentComp.length > 0) {
          let idx = this.currentComp.findIndex(e => e.code == sys.code);
          if (idx > -1) {
            this.currentComp.splice(idx, 1);
          }
        }
        if (this.compartmentList.length > 0) {
          let idx = this.compartmentList.findIndex(e => e.code == sys.code);
          if (idx > -1) {
            this.compartmentList[idx]['selected'] = false;
            this.compartmentList[idx]['visiable'] = false;
          }
        }
        console.log("clearCompartment ", this.currentComp);
        this.broadcastInfo({ src: 'sidepanel', event: 'clearCompartment', data: sys.code, key: "" });
      }
    }
  }
  filterCompartment(e) {
    this.filterComp = e;
  }

  sortCompartment(e) {
    this.sortComp = e;
    if (this.compartmentList.length > 0) {
      this.compartmentList.sort((a, b) => a[e] < b[e] ? -1 : a[e] > b[e] ? 1 : 0);
    }
  }
  searchDeckSelection(compartmentList) {
    var deckSelected = [];

    compartmentList.forEach(element => {
      if (element['code'] == "--") {
        element['code'] = element['name'];
      }
      if (element['code'].substring(0, 1).indexOf('0') > -1) {
        if (deckSelected.length > 0) {
          var deck = false;
          deckSelected.forEach((ele) => {
            if (ele.length == 1) {
              if (ele.substring(0, 1).toLowerCase() == element['code'].substring(0, 1).toLowerCase()) {
                deck = true;
              }
            }
            if (ele.length == 2) {
              if (ele.substring(0, 2).toLowerCase() == element['code'].substring(0, 2).toLowerCase()) {
                deck = true;
              }
            }
          })
          if (!deck) {
            deckSelected.push(element['code'].substring(0, 2).toUpperCase());
          }
        } else {
          deckSelected.push(element['code'].substring(0, 2).toUpperCase());
        }
      } else {
        if (element['code'].substring(0, 1).toLowerCase() == "z") {
          var deck = false;
          var otherDeck = (element['code'].substring(0, 2).toLowerCase() == 'za' || element['code'].substring(0, 2).toLowerCase() == 'zk' || element['code'].substring(0, 2).toLowerCase() == 'zk') ? '1' : (element['code'].substring(0, 2).toLowerCase() == 'zd' || element['code'].substring(0, 2).toLowerCase() == 'zh') ? '01' : '';
          if (otherDeck) {
            deckSelected.forEach((ele) => {
              if (ele.length == 1) {
                if (ele.substring(0, 1).toLowerCase() == otherDeck) {
                  deck = true;
                }
              }
              if (ele.length == 2) {
                if (ele.substring(0, 2).toLowerCase() == otherDeck) {
                  deck = true;
                }
              }
            })
            if (!deck) {
              deckSelected.push(otherDeck);
            }
          }

        } else {
          if (deckSelected.length > 0) {
            var deck = false;
            deckSelected.forEach((ele) => {
              if (ele.length == 1) {
                if (ele.substring(0, 1).toLowerCase() == element['code'].substring(0, 1).toLowerCase()) {
                  deck = true;
                }
              }
              if (ele.length == 2) {
                if (ele.substring(0, 2).toLowerCase() == element['code'].substring(0, 2).toLowerCase()) {
                  deck = true;
                }
              }
            })
            if (!deck) {
              deckSelected.push(element['code'].substring(0, 1).toUpperCase());
            }
          } else {
            deckSelected.push(element['code'].substring(0, 1).toUpperCase());
          }
        }

      }
    });
    // console.log("deckSelected", deckSelected,this.compartmentList,compartmentList);
    this.changeDeck(deckSelected);


    // if (this.currentComp.length > 0) {
    //   this.currentComp.forEach((e) => {
    //     this.clearCompartment(e);
    //   })
    // }
    if (deckSelected.length > 0) {
      this.selectedDeck = deckSelected;
    } else {
      this.selectedDeck = ['2'];
    }
    this.broadcastInfo({ src: 'sidepanel', event: 'filter-deck', data: this.selectedDeck, key: "" });
    console.log("deckSelected", deckSelected, this.compartmentList, compartmentList);
  }
  // searchDeckSelection() {
  //   var deckSelected;
  //   if (this.search == '') {
  //     this.searchValue();
  //   } else {
  //     if (isNaN(this.search[0]) && this.search[0].toLowerCase() != 'm') {
  //       this.searchValue();
  //     } else {
  //       if (this.search[0].indexOf('0') > -1) {
  //         if (this.search.length > 1) {
  //           deckSelected = this.selectedDeck == this.search.substring(0, 2).toLowerCase() ? this.selectedDeck : this.search.substring(0, 2);
  //         }
  //       } else {
  //         deckSelected = this.selectedDeck == this.search.substring(0, 1).toLowerCase() ? this.selectedDeck : this.search.substring(0, 1);
  //       }
  //       if (deckSelected) {
  //         let idx = this.deckList.findIndex(e => e.toLowerCase() == deckSelected.toLowerCase());
  //         if (idx > -1) {
  //           this.changeDeck(deckSelected.toUpperCase());
  //           this.searchValue();
  //         }
  //       }
  //     }
  //   }
  // }

  searchValue() {
    var filterData = [];
    var compartment;
    if (this.selectedDeck != '') {
      compartment = this.compartmentDeckList;
    } else {
      compartment = this.shipComp['compList'];
    }
    if (this.search == '') {
      // this.selectedDeck = ['2'];
      compartment = this.compartmentDeckList;
      filterData = compartment;
      // if (this.currentComp.length > 0) {
      //   this.currentComp.forEach((e) => {
      //     this.clearCompartment(e);
      //   })
      // }
      // this.broadcastInfo({ src: 'sidepanel', event: 'filter-deck', data: this.selectedDeck, key: "" });
    } else {
      if (compartment.length > 0) {
        for (let i = 0; i < compartment.length; i++) {
          this.filterComp.forEach((key) => {
            if (compartment[i][key].toLowerCase().indexOf(this.search.toLowerCase()) > -1) {
              const found = filterData.some(ship => ship.code === compartment[i]['code'])
              if (!found) {
                filterData.push(compartment[i]);
              }
            }
          })
        }
      }

    }
    this.compartmentList = filterData;
    // this.searchDeckSelection();
    this.sortCompartment('code');
    // this.khaConfig.matrixDataList.forEach(element => {
    //   if(element.name !="otherDeck"){
    //     element.visible = false;
    //   }
    //   this.selectedDeck.forEach(ele => {
    //     if (element.name == ele) {
    //       element.visible = true;
    //     }
    //   });
    // });
  }

  searchClear() {
    this.search = '';
    // this.selectedDeck = ['2'];
    if (this.selectedDeck.length > 0) {
      this.compartmentList = this.compartmentDeckList;
    } else {
      this.compartmentList = this.shipComp['compList'];
    }
    this.sortCompartment('code');
    // if (this.currentComp.length > 0) {
    //   this.currentComp.forEach((e) => {
    //     // this.clearCompartment(e);
    //   })
    // }
    // this.broadcastInfo({ src: 'sidepanel', event: 'filter-deck', data: this.selectedDeck, key: "" });
    // this.khaConfig.matrixDataList.forEach(element => {
    //   if(element.name !="otherDeck"){
    //     element.visible = false;
    //   }
    //   this.selectedDeck.forEach(ele => {
    //     if (element.name == ele) {
    //       element.visible = true;
    //     }
    //   });
    // });
  }


  expandCurrent(i) {
    const idx = this.comps.findIndex(el => el.component.toLowerCase() === 'kha');
    this.onChangekhaComp(this.comps[idx].compList[i]);
  }

  /* * *
  * method for change kha comp
  * * */
  onChangekhaComp(comp) {
    if (comp) {
      if (this.selectedKha) {
        if (this.selectedKha === comp['system'].split(" ").join("").toLowerCase()) {
          return
        }
      }
      this.selectedKha = comp['system'].split(" ").join("").toLowerCase();
      this.ctrlServe.selectedKha = this.selectedKha.split(" ").join("").toLowerCase();
      this.broadcastInfo({ src: 'sidepanel', event: 'changeshipcomp', data: this.selectedKha, comp: [] });
    }
  }

  showAllSystems(e) {
    let boo = e.checked
    this.showAllSystem = boo;
    this.broadcastInfo({ src: 'sidepanel', event: 'showhide-all-systems', data: boo, key: "" });
    if (!boo) {
      this.resetSubSystems();
    }
  }

  resetSubSystems() {
    this.broadcastInfo({ src: 'sidepanel', event: 'reset-sub-systems', data: '', key: "" });
  }

  currentTab = "compartment";
  selectedTabIndex = "1"
  onTabChanged($event) {
    if($event['index']=="0"){
      // if (this.currentComp.length > 0) {
      //   this.currentComp.forEach((e) => {
      //     setTimeout(() => {
      //       this.clearCompartment(e);
      //     })
      //   })
      // }
      // this.clearAllPresetSystem();
    }

    this.selectedTabIndex = $event['index'];
    let key = $event['index'] == 0 ? 'system' : 'compartment';
    this.currentTab = key;

    if (key === 'compartment') {
      this.selectedKha = "";
      this.showAllSystem = true;
    }
    this.broadcastInfo({ src: 'sidepanel', event: 'reset-views', data: '', key: key });
  }
  // layout and group functions

  // ToggleOpenHanddle() {
  //   this.shipHandleToggleOpen = !this.shipHandleToggleOpen;
  //   if (!this.shipHandleToggleOpen) {
  //     if (window.innerWidth > 541) {
  //     }
  //   }
  //   if (!this.shipHandleToggleOpen) {
  //     var elem = document.getElementsByClassName('side_panel');
  //     elem[0].classList.remove('open');
  //   } else {
  //   }
  // }
  showReportPanelOpen: any = true;
  shipReportHandleToggleOpen: any = false;
  ToggleReportOpenHanddle() {
    this.shipReportHandleToggleOpen = !this.shipReportHandleToggleOpen;
    if (!this.shipReportHandleToggleOpen) {
      if (window.innerWidth > 541) {
      }
    }
    if (!this.shipReportHandleToggleOpen) {
      var elem = document.getElementsByClassName('side_panel');
      elem[0].classList.remove('open');
    } else {
    }
  }
  ToggleGroupOpenHanddle() {
    this.shipGroupHandleToggleOpen = !this.shipGroupHandleToggleOpen;
    if (!this.shipGroupHandleToggleOpen) {
      if (window.innerWidth > 541) {
      }
    }
    if (!this.shipGroupHandleToggleOpen) {
      var elem = document.getElementsByClassName('side_panel');
      elem[0].classList.remove('open');
    } else {
    }
  }
  getPanelwidthWindow(e) {
    if (e == 'filterPanel') {
      let rawElem = document.getElementById('shipPanel');
      width = rawElem.offsetWidth;
      return width + 'px';
    } else {
      let elem = document.getElementById(e);
      if(elem!=null){
        var width = elem.offsetWidth;
        if (this.filterHandleToggleOpen) {
          let rawElem = document.getElementById('filterPanel');
          width += rawElem.offsetWidth;
        }
        if (this.serviceHandleToggleOpen) {
          let rawElem = document.getElementById('filterPanel');
          width += rawElem.offsetWidth;
        }
        if (e == 'toolPanel' || e == 'shipPanel_2' || e == 'servicesPanel' || e == 'cautionPanel') {
          let rawElem = document.getElementById(e);
          width = rawElem.offsetWidth;
          return width + 'px';
        }
        if (e == 'WFMPanel' || e == 'libPanel') {
          let rawElem = document.getElementById(e);
          width = rawElem.offsetWidth;
        }
  
        return 'translateX(' + width + 'px)';
      }else{
        return 'translateX(0px)';
      }
   
    }
  }
  alphabetOrder(data, key) {
    data.sort((a: any, b: any) => {
      if (a[key] < b[key]) {
        return -1;
      } else if (a[key] > b[key]) {
        return 1;
      } else {
        return 0;
      }
    });
    return data;
  }
  regEx(location) {
    return location;
  }
  regExReverse(location) {
    return location.replace(/\//g, "_").replace(/\s/g, '');
  }
  // search fuction

  searchData() {
    var layoutJson = [];
    // console.log("reconstrucuLayoutData", this.reconstrucuLayoutData)
    var filterData = [];
    if (this.searchLayout === '') {
      filterData = this.reconstrucuLayoutData;
      this.sidepanelGroupTagpoint = this.reconstrucuLayoutData;
    } else {
      if (this.reconstrucuLayoutData.length > 0) {
        for (let i = 0; i < this.reconstrucuLayoutData.length; i++) {
          if (this.filterLayoutKey.length > 0) {
            this.filterLayoutKey.forEach((key) => {
              if (typeof this.reconstrucuLayoutData[i][key] === 'string' && typeof this.searchLayout === 'string') {
                if (this.reconstrucuLayoutData[i][key].toLowerCase().indexOf(this.searchLayout.toLowerCase()) > -1) {
                  const found = filterData.some(el => el['id'] === this.reconstrucuLayoutData[i]['id']);
                  if (!found) {
                    filterData.push(this.reconstrucuLayoutData[i]);
                  }
                }
              }
            });
          } else {
            if (this.reconstrucuLayoutData[i].layoutName.toLowerCase().indexOf(this.searchLayout.toLowerCase()) > -1) {
              filterData.push(this.reconstrucuLayoutData[i]);
            }
          }
        }
      }
      // console.log("layoutJsondd", this.layoutJson)
      this.sidepanelGroupTagpoint = filterData;
    }
    layoutJson = []
    filterData.forEach(ele => {
      layoutJson.push({ 'layoutName': ele.layoutName, 'layoutId': ele.layoutId, isChecked: true });
    });
    var data = []
    layoutJson.forEach(el => {
      this.layoutJsonData.forEach(element => {
        if (el.layoutName == element.layoutName) {
          data.push(el);
        }
      });
    });
    this.filterdataComponentapply(filterData)
    data = data.reduce((a, b) => {
      if (!a.find(t => t.layoutId === b.layoutId)) {
        a.push(b);
      }
      return a;
    }, []);

    console.log("filterData", filterData)
    this.layoutJson = data
    // console.log("layoutJsondd", layoutJson, this.layoutJson, "test",data)

    // this.reConstructTagJson()
    // this.mappingCategory();
    this.sortByLayoutlist(this.sortlayoutItem);
  }
  //  clear search

  searchLayoutClear() {
    this.searchLayout = "";
    this.sidepanelGroupTagpoint = this.reconstrucuLayoutData;
    this.layoutJson = this.layoutJsonData;
    this.filterdataComponentapply(this.sidepanelGroupTagpoint)
    this.sortByLayoutlist(this.sortlayoutItem);
    let filterdData = null;
    // console.log("layoutJson", this.layoutJson)
    // this.mappingCategory();
  }

  sortByLayoutlist(e) {
    this.sortlayoutItem = e;
    let direction = 1;
    this.sidepanelGroupTagpoint.sort((a, b) => {
      // if (e == 'startdate' || e == 'enddate') {
      //   let aDate = new Date(a[e]);
      //   let bDate = new Date(b[e])
      //   if (aDate < bDate) {
      //     return -1 * direction;
      //   }
      //   else if (aDate > bDate) {
      //     return 1 * direction;
      //   }
      //   else {
      //     return 0;
      //   }
      // } else {
      if (a[e] < b[e]) {
        return -1 * direction;
      }
      else if (a[e] > b[e]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
      // }
    });

    // if (this.activeShipList) {
    //   let idx = this.sidepanelLayoutData.findIndex(e => e.id == this.activeShipList.id)
    //   if (idx > -1) {
    //     this.parentCatListIdx = idx;
    //   }
    // }
  }

  //  Class mapping ship meta data

  mappingCategory() {
    this.shipClassList = [];
    if (this.sidepanelLayoutData.length > 0) {
      this.sidepanelLayoutData.forEach(element => {
        if (this.shipClassList.indexOf(element.class) == -1) {
          this.shipClassList.push(element.class);
        }
      });
    }
  }
  getFilterKey(listData) {
    this.filterObjectKeys = [];
    this.filterObjectKeys = Object.keys(listData);
    // this.filterKey = this.filterObjectKeys;
  }
  filterToggle() {
    this.filterHandleToggleOpen = !this.filterHandleToggleOpen;
    if (window.innerWidth < 541) {
      this.ToggleOpenHanddle()
    }
  }



  // sortitem on change
  onChangeSortItem(event, key) {
    this.sortByLayoutlist(key);
  }

  // activeLayout(i) {
  //   this.activeLayoutIndex = i;
  // }

  // Group list
  // getGroupFilterKey(listGroupData) {
  //   this.filterGroupObjectKeys = [];
  //   this.filterGroupObjectKeys = Object.keys(listGroupData);
  //   this.filterGroupKey = this.filterGroupObjectKeys;
  //   // console.log("key", this.filterGroupKey)
  // }
  // search fuction
  searchGroupData() {
    var filterData = [];
    if (this.searchGroup === '') {
      filterData = null;
      this.sidepanelGroupData = this.sidepanelGroupObject;
    } else {
      if (this.sidepanelGroupObject.length > 0) {
        for (let i = 0; i < this.sidepanelGroupObject.length; i++) {
          if (this.filterGroupKey.length > 0) {
            this.filterGroupKey.forEach((key) => {
              if (typeof this.sidepanelGroupObject[i][key] === 'string' && typeof this.searchGroup === 'string') {
                if (this.sidepanelGroupObject[i][key].toString().toLowerCase().indexOf(this.searchGroup.toLowerCase()) > -1) {
                  const found = filterData.some(el => el.group_id === this.sidepanelGroupObject[i]['group_id']);
                  if (!found) {
                    filterData.push(this.sidepanelGroupObject[i]);
                  }
                }
              }
            });
          }
          // else {
          //   if (this.sidepanelGroupObject[i].groupName.toLowerCase().indexOf(this.searchGroup.toLowerCase()) > -1) {
          //     filterData.push(this.sidepanelGroupObject[i]);
          //   }
          // }
        }
      }
      this.sidepanelGroupData = filterData;
    }
    // this.mappingCategory();

    this.sortByGrouplist(this.sortItem);
  }
  //  clear search

  searchGroupClear() {
    this.searchGroup = "";
    this.sidepanelGroupData = this.sidepanelGroupObject;
    this.sortByGrouplist(this.sortItem);
    let filterdData = null;
    // this.mappingCategory();
  }

  sortByGrouplist(e) {
    this.sortItem = e;
    let direction = 1;
    this.sidepanelGroupData.sort((a, b) => {
      if (e == 'startdate' || e == 'enddate') {
        let aDate = new Date(a[e]);
        let bDate = new Date(b[e])
        if (aDate < bDate) {
          return -1 * direction;
        }
        else if (aDate > bDate) {
          return 1 * direction;
        }
        else {
          return 0;
        }
      } else {
        if (a[e] < b[e]) {
          return -1 * direction;
        }
        else if (a[e] > b[e]) {
          return 1 * direction;
        }
        else {
          return 0;
        }
      }
    });

    if (this.activeShipList) {
      let idx = this.sidepanelGroupData.findIndex(e => e.id == this.activeShipList.id)
      if (idx > -1) {
        this.parentCatListIdx = idx;
      }
    }
  }

  // sortitem on change
  onChangeGroupSortItem(event, key) {
    this.sortByGrouplist(key);
  }
  activeGroup(e) {
    // delete this.khaConfig.layoutName;
    // if (this.currentTab === "system") {
    //   this.onTabChanged({ index: 1 });
    // }
    // console.log("activeGroup", e)
    // this.activeGroupIndex = e._id;
    // if (e.groupList.length > 0) {
    //   if (this.currentComp.length > 0) {
    //     this.currentComp.forEach((e) => {
    //       this.clearCompartment(e);
    //     })
    //   }

    //   this.groupDeckSelected(e.groupList);
    // } else {
    //   alert("Group component not available")
    // }

  }
  groupDeckSelected(list) {
    var deckSelected = [];
    console.log("list", list, this.shipComp['compList']);
    // list.forEach(element=>{
    //   if (element['code'].substring(0, 2).indexOf('0') > -1) {
    //     if (deckSelected.length > 0) {

    //     }else{
    //       deckSelected.push(element['code'].substring(0, 2).toUpperCase());
    //     }
    //   }else{
    //     if (deckSelected.length > 0) {

    //     }else{
    //       deckSelected.push(element['code'].substring(0, 1).toUpperCase());
    //     }
    //   }
    // })
    // this.broadcastInfo({ src: 'sidepanel', event: 'groupList', data: list, key: "" });
    list.forEach(element => {
      if (element['code'].substring(0, 2).indexOf('0') > -1) {
        if (deckSelected.length > 0) {
          var deck = false;
          deckSelected.forEach((ele) => {
            if (ele.length == 1) {
              if (ele.substring(0, 1).toLowerCase() == element['code'].substring(0, 1).toLowerCase()) {
                deck = true;
              }
            }
            if (ele.length == 2) {
              if (ele.substring(0, 2).toLowerCase() == element['code'].substring(0, 2).toLowerCase()) {
                deck = true;
              }
            }
          })
          if (!deck) {

            // this.loadCompartment(element); 
            deckSelected.push(element['code'].substring(0, 2).toUpperCase());
          }
        } else {
          // this.loadCompartment(element); 
          deckSelected.push(element['code'].substring(0, 2).toUpperCase());
        }
      } else {
        if (deckSelected.length > 0) {
          var deck = false;
          deckSelected.forEach((ele) => {
            if (ele.length == 1) {
              if (ele.substring(0, 1).toLowerCase() == element['code'].substring(0, 1).toLowerCase()) {
                deck = true;
              }
            }
            if (ele.length == 2) {
              if (ele.substring(0, 2).toLowerCase() == element['code'].substring(0, 2).toLowerCase()) {
                deck = true;
              }
            }
          })
          if (!deck) {
            // this.loadCompartment(element); 
            deckSelected.push(element['code'].substring(0, 1).toUpperCase());
          }
        } else {
          // this.loadCompartment(element); 
          deckSelected.push(element['code'].substring(0, 1).toUpperCase());
        }
      }
    });
    // this.shipComp['compList'].forEach(element => {
    //   console.log(element.code);
    //   if (element['code'].substring(0, 2).indexOf('0') > -1) {
    //     if (deckSelected.length > 0) {
    //       var deck = false;
    //       list.forEach((ele) => {
    //         console.log("list",element.code,ele.code);
    //         if (ele['code'].length == 1) {
    //           if (ele['code'].substring(0, 1).toLowerCase() == element['code'].substring(0, 1).toLowerCase()) {
    //             deck = true;
    //           }
    //         }
    //         if (ele['code'].length == 2) {
    //           if (ele['code'].substring(0, 2).toLowerCase() == element['code'].substring(0, 2).toLowerCase()) {
    //             deck = true;
    //           }
    //         }
    //       })
    //       if (!deck) {
    //         deckSelected.push(element['code'].substring(0, 2).toUpperCase());
    //       }
    //     } else {
    //       deckSelected.push(element['code'].substring(0, 2).toUpperCase());
    //     }
    //   } else {
    //     if (deckSelected.length > 0) {
    //       var deck = false;
    //       deckSelected.forEach((ele) => {
    //         console.log("deckSelected",element.code,ele.code);
    //         if (ele.length == 1) {
    //           if (ele.substring(0, 1).toLowerCase() == element['code'].substring(0, 1).toLowerCase()) {
    //             deck = true;
    //           }
    //         }
    //         if (ele.length == 2) {
    //           if (ele.substring(0, 2).toLowerCase() == element['code'].substring(0, 2).toLowerCase()) {
    //             deck = true;
    //           }
    //         }
    //       })
    //       if (!deck) {
    //         deckSelected.push(element['code'].substring(0, 1).toUpperCase());
    //       }
    //     } else {
    //       deckSelected.push(element['code'].substring(0, 1).toUpperCase());
    //     }
    //   }
    // });
    console.log("groupdeckSelected", deckSelected);
    // this.changeDeck(deckSelected);


    // if (this.currentComp.length > 0) {
    //   this.currentComp.forEach((e) => {
    //     this.clearCompartment(e);
    //   })
    // }

    if (deckSelected.length > 0) {
      this.selectedDeck = deckSelected;

    } else {
      this.selectedDeck = ['2'];
    }
    //     this.showHideStruct('Hull','none');
    // this.showHideStruct('Bulkheads','none');
    // this.showHideStruct('Sections','none');
    // this.showHideStruct('OtherDecks','none');
    this.broadcastInfo({ src: 'sidepanel', event: 'filter-deck', data: this.selectedDeck, key: "" });
    this.onChangeDeck(this.selectedDeck);
    this.broadcastInfo({ src: 'sidepanel', event: 'groupMultipleLoadCompartment', data: list, key: "" });
    // this.changeMatrixHullAll('hide');
    //     this.changeMatrixbulkheadsAll('hide');
    //     this.changeMatrixSectionsAll('hide');
    // this.showHideStruct('OtherDecks', 'none');
    // this.showHideStruct('Hull','none');
    // this.showHideStruct('Bulkheads','none');
    // this.showHideStruct('Sections','none');
    // this.showHideStruct('OtherDecks','none');
  }

  // layout and group functions
  ToggleOpenHanddle() {
    this.shipHandleToggleOpen = !this.shipHandleToggleOpen;
    if (this.filterHandleToggleOpen)
      this.filterHandleToggleOpen = false;
    if (!this.shipHandleToggleOpen) {
      if (window.innerWidth > 541) {
      }
    }
    if (!this.shipHandleToggleOpen) {
      var elem = document.getElementsByClassName('side_panel');
      elem[0].classList.remove('open');
    } else {
    }
  }
  layoutTagState: any = false;
  activeLayoutId:any;
  activeLayout(event, i, layout, tag) {
    // this.khaConfig.loadedCompartment
    if (tag == false) {
      delete this.khaConfig.showLayoutTagData;
      delete this.khaConfig.showLayoutTagDataIdx;
    }
    let layoutId=layout;
    this.khaConfig.storedMeshComps = [];
    this.khaConfig.hideHighlightSelection();
    this.khaConfig.clearCutOuts();
    this.khaConfig.clearPointer();
    this.khaConfig.clearSections();
    console.log('layout', layout)
    // if (this.activeCardFlag) {
    //   this.activeCardFlag = false;
    // } else {
    //   delete this.khaConfig.showLayoutTagData;
    // }
    var layoutIDx = this.sidepanelLayoutData.findIndex(obj => obj._id == layout);
    this.sidepanelLayoutData[layoutIDx]['compartments'] = this.khaConfig.getLayoutCompartment(this.sidepanelLayoutData[layoutIDx]);
    layout = this.sidepanelLayoutData[layoutIDx];
    this.khaConfig.layoutTagList = [];
    this.layoutTagState = true;
    if (event) {
      if (event.target.classList.contains('delete_icon')) {
        return
      }
    }

    if (!layout) return;
    // this.resetDeck();
    delete this.activeGroupIndex;
    delete this.activeLayoutId;
    // this.onClearDeck();

    if (this.activeLayoutIndex == i) {
      delete this.activeLayoutIndex;
      delete this.activeLayoutId;
      if (this.currentTab === "system") {
        this.onTabChanged({ index: 1 });
      }
      this.layoutTag(this.activeLayoutIndex)
      this.currentComp.forEach((e) => {
        setTimeout(() => {
          this.clearCompartment(e);
        }, 300)
      });
      this.layoutCloseDetailData = [];
      this.broadcastInfo({ src: 'controlpanel', event: 'clear-layout-window', data: "", key: true });
    } else {
      this.activeLayoutIndex = i;
      this.activeLayoutId= layoutId;
      if (this.currentTab === "system") {
        this.onTabChanged({ index: 1 });
      }
      this.currentComp.forEach((e) => {
        setTimeout(() => {
          this.clearCompartment(e);
        }, 300)
      });

      setTimeout(() => {
        this.resetWallmode();
        this.currentComp = [];
        layout['compartments'].forEach(item => {
          const found = this.currentComp.some(el => el.code == item.code);
          if (!found) {
            let idx = this.shipComp['compList'].findIndex(e => e.code == item.code);
            if (idx > -1) {
              this.shipComp['compList'][idx]['selected'] = true;
              this.shipComp['compList'][idx]['visiable'] = true;
              this.currentComp.push(this.shipComp['compList'][idx]);
            }
          }
        });
        if (event) {
          if (event.target.classList.contains('l-pos') || event.target.classList.contains('spanHead')) {
            layout['tagPoints'].forEach(ele => {
              let idx = this.sidepanelGroupTagpoint.findIndex(e => e.id == ele['id']);
              this.sidepanelGroupTagpoint[idx]['tagShowState'] = true;

            });
          }
        }
        console.log("activeLayout", this.sidepanelGroupTagpoint);
        this.selectedLayoutList = JSON.stringify(layout);
        this.layoutCloseDetailData = JSON.parse(this.selectedLayoutList);
        var tagpoint = this.layoutCloseDetailData['tagPoints']
        var tagCom = tagpoint
        // this.layoutCloseDetailData.forEach(lay => {
          // lay['tagPoints'].forEach(tagpoint => {
            tagCom.forEach(tagcom => {
              var tag = tagcom.tagComments
              // if (tagcom.tagComments) {
                // tagcom['tagComments'].forEach(tag => {
                if (tag && tag.statusId) {
                  let filteredStatus = this.sidepanelStatusData.filter(m => m._id == tag.statusId);
                  var statusData = filteredStatus[0]
                  if (statusData != undefined) {
                    tag.statusName = statusData.name;
                    tag.statusColor = statusData.value;
                  }
                  if (statusData == undefined) {
                    tag.statusName = '';
                    tag.statusColor = '';
                  }
                }
              // });
              // }
            });
          // });
        // });
        this.broadcastInfo({ src: 'controlpanel', event: 'load-mutiple-compartment', data: layout, key: true });

        if (layout['tagPoints'].length > 0) {
          if (layout['compartments'].length > 0) {
            this.searchDeckSelection(layout['compartments']);
          } else {
            if (layout['compartments'].length > 0) {
              this.searchDeckSelection(layout['compartments']);
            }
          }

        }
        // this.changeMatrixHullAll('hide');
        // this.changeMatrixbulkheadsAll('hide');
        // this.changeMatrixSectionsAll('hide');
        // this.showHideStruct('Hull','none');
        // this.showHideStruct('Bulkheads','none');
        // this.showHideStruct('Sections','none');
        // this.showHideStruct('OtherDecks','none');
        
      }, 1000);
      // this.tagFlagCheck();
    }
  }
  tagFlagCheck(){
    this.activeLayoutTag;
    this.activeLayoutTagCard;
    this.activeCard = this.activeCards;
    // setTimeout(() => {
      if (this.sidepanelLayoutData.length > 0) {
        this.sidepanelLayoutData.forEach(element => {
          if (element['_id'] == this.activeLayoutTag) {
            element['tagPoints'].forEach(ele => {
              if (ele['id'] != this.activeLayoutTagCard['id']) {
                let idx = this.sidepanelGroupTagpoint.findIndex(e => e.id == this.activeLayoutTagCard['id']);
                if (idx > -1) {
                  this.sidepanelGroupTagpoint[idx]['tagShowState'] = false;
                  this.broadcastInfo({ src: 'material', event: 'layoutTagClose', data: ele });
                } else {
                  this.sidepanelGroupTagpoint[idx]['tagShowState'] = true;
                }
              }else{
                let idx = this.sidepanelGroupTagpoint.findIndex(e => e.id == this.activeLayoutTagCard['id']);
                this.sidepanelGroupTagpoint[idx]['tagShowState'] = true;
              }
            });
          }
        });
        console.log("layoutLoadFromNote", this.sidepanelGroupTagpoint);
      }
    // }, 2000);
  }
  layoutTagHide(i) {
    this.layoutTagState = false;
    if (this.sidepanelLayoutData.length > 0 && this.sidepanelLayoutData[i]) {
      if (this.sidepanelLayoutData[i]['tagPoints'].length > 0) {
        this.sidepanelLayoutData[i]['tagPoints'].forEach(element => {
          element.tagShowState = this.layoutTagState;
          this.khaConfig.showLayoutTag(element, this.layoutTagState);
        });

      }
    }
    if (this.layoutTagState == false) {
      this.activeCard = undefined;
    }

  }
  layoutTag(i) {
    this.layoutTagState = !this.layoutTagState;
    if (this.sidepanelLayoutData.length > 0 && this.sidepanelLayoutData[i]) {
      if (this.sidepanelLayoutData[i]['tagPoints'].length > 0) {
        this.sidepanelLayoutData[i]['tagPoints'].forEach(element => {
          element.tagShowState = this.layoutTagState;
          this.khaConfig.showLayoutTag(element, this.layoutTagState);
        });

      }
    }
    if (this.layoutTagState == false) {
      this.activeCard = undefined;
    }

  }
  selectedLayoutDeleteData = {}
  OnDeleteLayout(i, layout) {
    var layoutIDx = this.sidepanelLayoutData.findIndex(obj => obj._id == layout)
    layout = this.sidepanelLayoutData[layoutIDx]
    this.selectedLayoutDeleteData = { i, layout };
    this.broadcastInfo({ src: 'material', event: 'openDialogConfirmLayoutDelete', data: "", key: true });
  }

  deleteLayoutData() {
    if (Object.keys(this.selectedLayoutDeleteData).length === 0) return;
    let idx = this.selectedLayoutDeleteData['i'] || -1;
    let layoutID = this.selectedLayoutDeleteData['layout']['_id'] || ''
    if (layoutID) {
      if (idx === this.activeLayoutIndex) {
        delete this.activeLayoutIndex;
        if (this.currentTab === "system") {
          this.onTabChanged({ index: 1 });
        }
        this.currentComp.forEach((e) => {
          setTimeout(() => {
            this.clearCompartment(e);
          }, 300)
        });
        this.broadcastInfo({ src: 'controlpanel', event: 'clear-layout-window', data: "", key: true });
      }
      this.sidepanelLayoutData.splice(idx, 1);
      this.broadcastInfo({ src: 'controlpanel', event: 'delete-layout-data', data: layoutID, key: '' });
      this.selectedLayoutDeleteData = {};
    }
  }
  selectedGroupDeleteData = {};
  OnDeleteGroup(i, group) {
    this.selectedGroupDeleteData = { i, group };
    this.broadcastInfo({ src: 'material', event: 'openDialogConfirmGroupDelete', data: "", key: true });
  }
  deleteGroupData() {
    if (Object.keys(this.selectedGroupDeleteData).length === 0) return;
    let idx = this.selectedGroupDeleteData['i'] || -1;
    let groupID = this.selectedGroupDeleteData['group']['_id'] || ''
    if (groupID) {
      if (groupID === this.activeGroupIndex) {
        delete this.activeGroupIndex;
        if (this.currentTab === "system") {
          this.onTabChanged({ index: 1 });
        }
        this.broadcastInfo({ src: 'controlpanel', event: 'clear-group-window', data: "", key: true });
      }
      this.sidepanelGroupData.splice(idx, 1);
      this.broadcastInfo({ src: 'controlpanel', event: 'delete-group-data', data: groupID, key: '' });
      this.selectedGroupDeleteData = {};
    }
  }
  changeMatrixHull(i, e) {
    this.khaConfig.matrixDataList.forEach((element, idx) => {
      if (idx == i && element.name != "otherDeck") {
        element.hull = e;
        var name = element.name;
        // this.khaConfig.applyState_Hull(e, name, this.khaConfig.matrixDataList);
      }
      if (idx == i && element.name == "otherDeck") {
        element.hull = e;
        this.showHideStruct('otherDecks', e)
      }
    });
  }
  changeMatrixBulkheads(i, e) {
    this.khaConfig.matrixDataList.forEach((element, idx) => {
      if (idx == i) {
        element.bulkheads = e;
        var name = element.name;
        // this.khaConfig.applyState_Bulkheads(e, name,this.khaConfig.matrixDataList)
      }
    });
  }
  changeMatrixSections(i, e) {
    this.khaConfig.matrixDataList.forEach((element, idx) => {
      if (idx == i) {
        element.sections = e;
        var name = element.name;
        // this.khaConfig.applyState_Sections(e, name,this.khaConfig.matrixDataList)
      }
    });
  }
  changeMatrixHullAll(e) {
    this.hullAllStatus = e;
    this.khaConfig.matrixDataList.forEach(element => {
      this.selectedDeck.forEach(ele => {
        element.hull = e;
      });
    })
    // this.khaConfig.applyState_Hull(e,'', this.khaConfig.matrixDataList)
  }
  changeMatrixbulkheadsAll(e) {
    this.bulkheadsAllStatus = e;
    this.khaConfig.matrixDataList.forEach(element => {
      this.selectedDeck.forEach(ele => {
        element.bulkheads = e;
      });
    })
    // this.khaConfig.applyState_Bulkheads(e,'', this.khaConfig.matrixDataList)
  }

  changeMatrixSectionsAll(e) {
    this.sectionsAllStatus = e;
    this.khaConfig.matrixDataList.forEach(element => {
      this.selectedDeck.forEach(ele => {
        element.sections = e;
      });
    })
    // this.khaConfig.applyState_Sections(e,'', this.khaConfig.matrixDataList)
  }
  commentstatus(data) {
    this.statusUpdated = data


  }
  statusChange(data, layOut, tagpoint, status) {
    var statusId = this.sidepanelStatusData.filter(obj => obj.name == status)
    var statusIdData = statusId[0]._id;
    // this.broadcastInfo({ src: 'sidepanel', event: 'update-Status', data: statusId, });
    var layoutIDx = this.sidepanelLayoutData.findIndex(obj => obj._id == layOut)
    layOut = this.sidepanelLayoutData[layoutIDx]
    console.log('layout', layOut)
    var statusIDX = this.sidepanelStatusData.findIndex(obj => obj.name == status)
    var selectTag = layOut.tagPoints.filter(obj => obj.id == tagpoint.id)
    data.status = this.sidepanelStatusData[statusIDX]
    data.statusId = statusIdData;
    this.broadcastInfo({ src: 'comment', event: 'update-comment', data: data, "layOut": layOut, "selectTag": selectTag[0] });
  }
  getDate(date) {
    return this.datepipe.transform(date, "MMM d, y, h:mm a")
  }
  // onChangeGroupItem(event , key){
  //   this.selectedGroupItem = key
  // }
  onChangeActivity(event, status) {
    console.log(this.selectedLayoutList)
    this.sortByLayoutlist(this.sortlayoutItem);
    if (!event.checked) {
      var idx = this.statusFilter.findIndex(obj => obj.statusName == status)
      this.statusFilter[idx].isChecked = false;
      this.activitySelectStatus = false;
      this.sidepanelGroupTagpoint = this.sidepanelGroupTagpoint.filter(obj => obj.statusName != status)
      this.groupJson = [];
      this.sidepanelGroupTagpoint.forEach(ele => {
        this.groupJson.push({ "groupName": ele.groupName, "groupColor": ele.groupColor, isChecked: true, 'layoutId': ele.layoutId })
      })
      const groupids = this.groupJson.map(o => o.groupName)
      this.groupJson = this.groupJson.filter(({ groupName }, index) => !groupids.includes(groupName, index + 1));
    } else {
      var idx = this.statusFilter.findIndex(obj => obj.statusName == status)
      this.statusFilter[idx].isChecked = true;
      var count = 0
      this.statusFilter.forEach(obj => {
        if (obj.isChecked != true) {
          count++
        }
      })
      if (count == 0) {
        this.activitySelectStatus = true
      }
      let tagList = {}
      this.sidepanelLayoutData.forEach(element => {
        //this.layoutJson.push({'layoutName': element.layoutName,'layoutId': element._id})
        element.tagPoints.forEach(tagpoint => {
          tagList = tagpoint
          var compartmentIdx = element.compartments.findIndex(obj => obj.code == tagpoint.code);
          var compoentsIdx = element.components.findIndex(obj => obj.name == tagpoint.partId);
          if (tagpoint.groupData) {
            tagList['groupName'] = tagpoint.groupData.name;
            tagList['groupColor'] = tagpoint.groupData.color;
          }
          // this.groupJson.push({"groupName": tagpoint.groupName,"groupColor":tagpoint.groupColor, isChecked : true,'layoutId': element._id})
          console.log(this.groupJson)
          if (tagpoint.tagComments) {
            if (tagpoint.tagComments.startDate) {
              tagList['startDate'] = tagpoint.tagComments.startDate
            }
            if (tagpoint.tagComments.status) {
              tagList['statusName'] = tagpoint.tagComments.status.name;
              tagList['statusColor'] = tagpoint.tagComments.status.value;
            }
          }
          //this.statusFilter.push({"statusName":  tagList['statusName'],"statusColor":tagList['statusColor'], isChecked : true,'layoutId': element._id})
          tagList['layoutId'] = element._id;
          tagList['layoutName'] = element.layoutName;
          tagList['componentName'] = tagpoint['name'];
          if (compartmentIdx != -1) {
            tagList['compartmentName'] = element.compartments[compartmentIdx].name;
          } if (compoentsIdx != -1) {
            tagList['compoentsPosition'] = element.components[compoentsIdx].position;
          }
          if (tagList['statusName'] == status) {
            this.sidepanelGroupTagpoint.push(tagList)
          }
        })

      });
      this.groupJson = [];
      this.sidepanelGroupTagpoint.forEach(ele => {
        this.groupJson.push({ "groupName": ele.groupName, "groupColor": ele.groupColor, isChecked: true, 'layoutId': ele.layoutId })
      })
      const groupids = this.groupJson.map(o => o.groupName)
      this.groupJson = this.groupJson.filter(({ groupName }, index) => !groupids.includes(groupName, index + 1));
    }
    // this.filterdataComponentapply(this.sidepanelGroupTagpoint)
    this.clearLayoutCheck();

  }
  onChangeGroup(event, status) {
    this.sortByLayoutlist(this.sortlayoutItem);
    if (!event.checked) {
      this.statusFilter = []
      this.sidepanelGroupTagpoint = this.sidepanelGroupTagpoint.filter(obj => obj.groupName != status)
      this.sidepanelGroupTagpoint.forEach(ele => {
        this.statusFilter.push({ "statusName": ele['statusName'], "statusColor": ele['statusColor'], isChecked: true, 'layoutId': ele.layoutId })
      })
      var idx = this.groupJson.findIndex(obj => obj.groupName == status)
      this.groupJson[idx].isChecked = false;
      this.activitySelectGroupAll = false;
      const statusids = this.statusFilter.map(o => o.statusName)
      this.statusFilter = this.statusFilter.filter(({ statusName }, index) => !statusids.includes(statusName, index + 1))
      console.log(this.statusFilter)
    } else {
      let tagList = {}
      this.sidepanelLayoutData.forEach(element => {
        element.tagPoints.forEach(tagpoint => {
          tagList = tagpoint
          var compartmentIdx = element.compartments.findIndex(obj => obj.code == tagpoint.code);
          var compoentsIdx = element.components.findIndex(obj => obj.name == tagpoint.partId);
          if (tagpoint.groupData) {
            tagList['groupName'] = tagpoint.groupData.name;
            tagList['groupColor'] = tagpoint.groupData.color;

          }
          if (tagpoint.tagComments) {
            if (tagpoint.tagComments.startDate) {
              tagList['startDate'] = tagpoint.tagComments.startDate;
            }
            if (tagpoint.tagComments.status) {
              tagList['statusName'] = tagpoint.tagComments.status.name;
              tagList['statusColor'] = tagpoint.tagComments.status.value;
            }
          }
          tagList['layoutId'] = element._id;
          tagList['layoutName'] = element.layoutName;
          if (compartmentIdx != -1) {
            tagList['compartmentName'] = element.compartments[compartmentIdx].name;
          } if (compoentsIdx != -1) {
            tagList['compoentsPosition'] = element.components[compoentsIdx].position;
          }
          if (tagpoint.groupName == status) {
            this.sidepanelGroupTagpoint.push(tagList)
          }
        })

      });
      var idx = this.groupJson.findIndex(obj => obj.groupName == status)
      this.groupJson[idx].isChecked = true;
      var count = 0
      this.statusFilter.forEach(obj => {
        if (obj.isChecked != true) {
          count++
        }
      })
      if (count == 0) {
        this.activitySelectGroupAll = true
      }
      this.sidepanelGroupTagpoint.forEach(ele => {
        this.statusFilter.push({ "statusName": ele['statusName'], "statusColor": ele['statusColor'], isChecked: true, 'layoutId': ele.layoutId })
      })
      const statusids = this.statusFilter.map(o => o.statusName)
      this.statusFilter = this.statusFilter.filter(({ statusName }, index) => !statusids.includes(statusName, index + 1))
      console.log(this.sidepanelGroupTagpoint);
    }
    this.groupJson.forEach(el => {
      if (el.isChecked == false) {
        this.activitySelectGroupAll = false;
      }
    });
    this.filterdataComponentapply(this.sidepanelGroupTagpoint)
    this.clearLayoutCheck();
  }
  clearLayoutCheck() {
    // if(this.sidepanelGroupTagpoint.length>0){
    //   if(this.activeLayoutIndex){
    //     let idx=this.sidepanelGroupTagpoint.findIndex(e=> e['layoutId']==this.layoutJson[this.activeLayoutIndex]['layoutId']);
    //     if(idx==-1){
    //       this.broadcastInfo({ src: 'sidepanel', event: 'resetLayout' });
    //     }
    //   }
    // }else{
    //   this.broadcastInfo({ src: 'sidepanel', event: 'resetLayout' });
    // }
  }
  activeCard: any;
  activeLayoutTag: any;
  activeLayoutTagCard: any;
  activeCards: any;
  // activeCardFlag = false;
  openLayoutTag(event, i, layout, tag, tagIdx) {
    if (event) {
      if (event.target.classList.contains('status-change')) {
        return
      }
      if (event.target.classList.contains('Notes_delete_icon')) {
        return
      }
    }
    this.activeLayoutTag = layout;
    this.activeLayoutTagCard = tag;
    this.activeCard = tagIdx;

    this.khaConfig.showLayoutTagData = tag;
    this.khaConfig.showLayoutTagDataIdx = tagIdx;
    // this.activeCardFlag = true;
    this.layoutTagHide(i);

    let idx = this.sidepanelGroupTagpoint.findIndex(e => e.id == tag['id']);
    if (this.activeLayoutIndex != undefined) {
      if (this.layoutJson[this.activeLayoutIndex]['layoutId'] == layout) {
        if (this.sidepanelGroupTagpoint[idx]['tagShowState']) {
          this.sidepanelGroupTagpoint[idx]['tagShowState'] = false;
          this.broadcastInfo({ src: 'material', event: 'layoutTagOpen', data: tag, status: false });
          this.activeCard = undefined;
          this.layoutTagState = false
        } else {
          this.sidepanelGroupTagpoint[idx]['tagShowState'] = true;
          this.broadcastInfo({ src: 'material', event: 'layoutTagOpen', data: tag, status: true });
          this.activeCard = tagIdx;
          this.layoutTagState = true
        }
      } else {
        this.activeLayout(event, this.activeLayoutIndex, this.layoutJson[this.activeLayoutIndex]['layoutId'], true);
        // setTimeout(() => {
        this.layoutLoadFromNote(event, i, layout, tag)
        // }, 1000);        
      }
    } else {
      this.layoutLoadFromNote(event, i, layout, tag)
    }
    if (this.sidepanelLayoutData) {
      this.sidepanelLayoutData.forEach(element => {
        if (element['_id'] == layout) {
          const found = tag.name.split("_")
          if (found[0] == 'marker') {
            if ( element['markers'].length > 0) {
              var markerData = element['markers'].filter(m => m.uid+'_slicer' == tag.name);
              // element['markers'].forEach(ele => {
                if (markerData[0] == undefined || markerData[0].uid+'_slicer' != tag['name']) {
                  this.broadcastInfo({ src: 'coursePanel', event: 'openDialog', data: "Marker failed to save. Please delete and recreate." });
                }
              // });
            } else {
              this.broadcastInfo({ src: 'coursePanel', event: 'openDialog', data: "Marker failed to save. Please delete and recreate." });
            }
          }
        }
      });
    }
  }

  layoutLoadFromNote(event, i, layout, tag) {
    this.activeLayout(event, i, layout, true);
    // this.broadcastInfo({ src: 'material', event: 'layoutTagOpen', data: tag,status:true });
    setTimeout(() => {
      if (this.sidepanelLayoutData.length > 0) {
        this.sidepanelLayoutData.forEach(element => {
          if (element['_id'] == layout) {
            element['tagPoints'].forEach(ele => {
              if (ele['id'] != tag['id']) {
                let idx = this.sidepanelGroupTagpoint.findIndex(e => e.id == tag['id']);
                if (idx > -1) {
                  this.sidepanelGroupTagpoint[idx]['tagShowState'] = false;
                  this.broadcastInfo({ src: 'material', event: 'layoutTagClose', data: ele });
                } else {
                  this.sidepanelGroupTagpoint[idx]['tagShowState'] = true;
                }

              }
            });
          }
        });
        console.log("layoutLoadFromNote", this.sidepanelGroupTagpoint);
      }
    }, 2000);
  }

  checkGroup() {
    var status = false;
    if (this.groupJson.length > 0) {
      this.groupJson.forEach(element => {
        if (element.groupName != "Group Name") {
          status = true;
        }
      });
    } else {
      status = false;
    }
    return status;
  }
  onChangelayout(event, layoutID) {
    this.sortByLayoutlist(this.sortlayoutItem);
    if (!event.checked) {
      this.layoutJson = this.layoutJson.filter(obj => obj.layoutId != layoutID)
      let groupjsonData = []
      let statusFilterData = []
      this.layoutJson.forEach(element => {
        this.groupJson.forEach(ele => {
          if (ele.layoutId == element.layoutId) {
            groupjsonData.push({ "groupName": ele.groupName, "groupColor": ele.groupColor, isChecked: true, 'layoutId': ele.layoutId })
          }
        });
        this.sidepanelGroupTagpoint.forEach(ele => {
          if (ele.layoutId == element.layoutId) {
            statusFilterData.push(ele)
          }
        });
      });
      const statusids = statusFilterData.map(o => o.statusName)
      this.statusFilter = statusFilterData.filter(({ statusName }, index) => !statusids.includes(statusName, index + 1));
      this.statusFilter.forEach(elem => {
        elem.isChecked = true;
      })
      var idx = this.filterLayoutJson.findIndex(obj => obj.layoutId == layoutID)
      this.filterLayoutJson[idx].isChecked = false;
      this.activitylayoutstaus = false;
      this.groupJson = groupjsonData;
      // this.statusFilter = statusFilterData;
      console.log("", this.groupJson)
      //this.filterLayoutJson = this.layoutJson.filter(obj => obj.layoutId != layoutID)
    } else {
      this.sidepanelLayoutData.forEach(element => {
        if (element._id == layoutID) {
          //this.groupJson.push({"groupName": element.groupName,"groupColor":element.groupColor, isChecked : true,'layoutId': element._id})
          this.layoutJson.unshift({ 'layoutName': element.layoutName, 'layoutId': element._id })
        }
      });
      var idx = this.filterLayoutJson.findIndex(obj => obj.layoutId == layoutID)
      this.filterLayoutJson[idx].isChecked = true;
      var count = 0
      this.statusFilter.forEach(obj => {
        if (obj.isChecked != true) {
          count++
        }
      })
      if (count == 0) {
        this.activitylayoutstaus = true
      }
      this.sidepanelGroupTagpoint = this.reconstrucuLayoutDataList;
      this.sidepanelGroupTagpoint.forEach(element => {
        if (element.layoutId == layoutID) {
          this.groupJson.push({ "groupName": element.groupName, "groupColor": element.groupColor, isChecked: true, 'layoutId': element.layoutId })
          this.statusFilter.push({ "statusName": element['statusName'], "statusColor": element['statusColor'], isChecked: true, 'layoutId': element.layoutId })
        }
      });
    }
    this.filterLayoutJson.forEach(el => {
      if (el.isChecked == false) {
        this.activitylayoutstaus = false;
      }
    });
    const statusids = this.statusFilter.map(o => o.statusName)
    this.statusFilter = this.statusFilter.filter(({ statusName }, index) => !statusids.includes(statusName, index + 1));
    const groupids = this.groupJson.map(o => o.groupName)
    this.groupJson = this.groupJson.filter(({ groupName }, index) => !groupids.includes(groupName, index + 1));
   this.filterdataComponentapply(this.sidepanelGroupTagpoint)
    this.clearLayoutCheck();
  }
  activitySelectAll(checked) {
    if (checked) {
      this.reConstructTagJson();
      this.statusFilter.forEach(ele => ele.isChecked = true);
    } else {
      this.sidepanelGroupTagpoint = []
      this.groupJson = [];
      this.activitySelectStatus = true;
      this.activitySelectGroupAll = true;
      this.statusFilter.forEach(ele => ele.isChecked = false);
    }
    this.filterdataComponentapply(this.sidepanelGroupTagpoint)
    this.clearLayoutCheck();
  }
  activitySelectGroup(checked) {
    if (checked) {
      this.reConstructTagJson();
    } else {
      this.sidepanelGroupTagpoint = [];
      this.statusFilter = [];
      this.activitySelectStatus = true;
      this.groupJson.forEach(ele => ele.isChecked = false);
    }
    this.filterdataComponentapply(this.sidepanelGroupTagpoint)
    this.clearLayoutCheck();
  }
  activitySelectlayoutAll(checked) {
    if (checked) {
      this.reConstructTagJson();
      this.filterLayoutJson.forEach(ele => ele.isChecked = true);
    } else {
      this.sidepanelGroupTagpoint = [];
      this.statusFilter = [];
      this.groupJson = [];
      this.layoutJson = [];
      this.filterLayoutJson.forEach(ele => ele.isChecked = false);
    }
    this.filterdataComponentapply(this.sidepanelGroupTagpoint)
    this.clearLayoutCheck();
  }
  resetFilter() {
    this.activitySelectlayoutAll(true);
    this.activitySelectStatus = true;
    this.activitySelectGroup(true);
    this.activitySelectGroupAll = true;
    this.activitySelectAll(true);
    this.activitylayoutstaus = true;
  }

  onChange(item, event) {
    console.log(item)
    console.log()
    item.color = event;
    this.configService.updateGroup(item._id, item).then(reuslt => {
      this.reConstructTagJson()
    })
    //this.khaConfig.hideHighlightSelection()
    this.broadcastInfo({ src: "shipDetail", event: "groupColorUpdated", data: item })
  }
  onChangeColor(item) {
    this.groupStatusColor = item.color;
  }
  onChangeColorClick(event) {
    console.log(event)
  }
  createGroup() {
    this.broadcastInfo({ src: "sidepanel", event: "createGroup", data: "" })
  }
  editGroup(e) {
    this.broadcastInfo({ src: "sidepanel", event: "updateGroup", data: e })
  }
  /**
   * clear preset system
   */
  clearPresetSystem(s) {
    this.current_preset = null;
    const idx = this.comps.findIndex(el => el.component.toLowerCase() === 'presets');

    this.comps[idx].compList.forEach(sys => {
        if (sys['name'] == s.name) {
          sys.selected = !true;
        }
     
    });
    this.broadcastInfo({ src: 'controlpanel', event: 'clear-system', data: s, key: '' });
  }
    /**
   * clear preset system
   */
     clearAllPresetSystem() {
      this.current_preset = null;
      const idx = this.comps.findIndex(el => el.component.toLowerCase() === 'presets');
  
      this.comps[idx].compList.forEach(sys => {
        // if (sys['code'] == s.code) {
          sys.selected = !true;
          this.broadcastInfo({ src: 'controlpanel', event: 'clear-system', data: sys, key: '' });
        // }
      });
      // this.broadcastInfo({ src: 'controlpanel', event: 'clear-system', data: s, key: '' });
    }
  /**
   * load preset system
   */
  current_preset = null
  processSystem(s) {
    if (this.current_preset === s.code) {
      return
    }
    let show = true;
    let returnValue = false;
    const idx = this.comps.findIndex(el => el.component.toLowerCase() === 'presets');

    this.comps[idx].compList.forEach(sys => {
      console.log("compList",s.code,sys['code'])
      if (sys['code'].sort().join(',').toLowerCase() == s.code.sort().join(',').toLowerCase()) {
        console.log("true",sys['code'] == s.code)
        sys.selected = true;
        show = true;
      }
    });
    this.current_preset = s.code
    this.broadcastInfo({ src: 'controlpanel', event: 'process-system', data: s, key: show });
  }

  filterdataComponentapply(data) {
    this.layoutCloseDetailData.tagPoints = []
    if (data.length != 0) {
      data.forEach(ele => {
        //this.groupJson.push({ "groupName": ele.groupName, "groupColor": ele.groupColor, isChecked: true, 'layoutId': ele.layoutId })
        if (this.layoutCloseDetailData._id == ele.layoutId) {
          this.layoutCloseDetailData.tagPoints.push(ele)
        }
      })
    }
    this.khaConfig.layoutFilterChanges(this.layoutCloseDetailData)
  }
  closeCompartmentList(sys) {
    sys.visiable = false;
    sys.selected = false;
    this.clearCompartmentList(sys)
    this.broadcastInfo({ src: 'sidepanel', event: 'deleteCompartments', data: sys });
   }
   markerName: any;
   deleteNotesConfirm(layoutid ,id, tag){
    // this.selectedLayoutList
    this.markerName = tag.name;
     this.selectedNotesId = id;
     this.layoutId  = layoutid;
    //  return;
    this.broadcastInfo({ src: 'material', event: 'openDialogConfirmLayoutNotesDelete', data: this.layoutId, 'notesId': this.selectedNotesId, sub: null });
   }
   deleteNotes() {
    this.broadcastInfo({ src: 'material', event: 'layoutTagCloseActive', data: '' });
    var selectedLayout = this.sidepanelLayoutData.filter(elem => elem._id == this.layoutId)
    var notesIdx = selectedLayout[0].tagPoints.findIndex(ele => ele.id == this.selectedNotesId)
    var markerIdx = selectedLayout[0].markers.findIndex(ele => ele.uid+'_slicer' == this.markerName)
    var notesData = selectedLayout[0].tagPoints.filter(ele => ele.id == this.selectedNotesId)
    var markerId =  selectedLayout[0].markers.filter(ele => ele.uid+'_slicer' == this.markerName)
    
    var layoutData = JSON.parse(JSON.stringify(selectedLayout[0]));
    layoutData.tagPoints = notesData;
    layoutData.markers = markerId;
    
    selectedLayout[0].tagPoints.splice(notesIdx, 1)
    selectedLayout[0].markers.splice(markerIdx, 1)
    
    this.configService.deleteTagpoint(this.layoutId, layoutData).then(data => {
      if (data) {
        console.log("Layout updated ", data);
        this.broadcastInfo({ src: 'khaservice', event: 'hideloader', data: '' });
        // this.khaConfig.hidePointerData(markerData[1]);
        if(markerId.length > 0){
          this.khaConfig.deleteMarker(markerId[0].uid)
          setTimeout(() => {
            this.khaConfig.marker_history = [];
          }, 300);
        }
      }
    }).catch((error) => {
      console.log("error ", error);
    });
    this.reConstructTagJson()
    if (this.selectedLayoutList.length != 0) {
      this.filterdataComponentapply(selectedLayout[0].tagPoints)
    }
    this.broadcastInfo({ src: 'comment', event: 'notesDelete', data: notesData[0], sub: null });
    this.khaConfig.hidePointerData(this.selectedNotesId);
    // if(this.layoutTagState){
    //   this.layoutTag(this.activeLayoutIndex);
    // }
    // this.layoutTag(this.activeLayoutIndex);
  }


  // Start Status

  ToggleStatusOpenHanddle() {
    this.shipStatusHandleToggleOpen = !this.shipStatusHandleToggleOpen;
    if (!this.shipStatusHandleToggleOpen) {
      if (window.innerWidth > 541) {
      }
    }
    if (!this.shipStatusHandleToggleOpen) {
      var elem = document.getElementsByClassName('side_panel');
      elem[0].classList.remove('open');
    } else {
    }
  }
  createStatus() {
    this.broadcastInfo({ src: "sidepanel", event: "createStatus", data: "" })
  }
  // search fuction
  searchStatusData() {
    var filterData = [];
    if (this.searchStatus === '') {
      filterData = null;
      this.sidepanelStatusData = this.sidepanelStatusObject;
    } else {
      if (this.sidepanelStatusObject.length > 0) {
        for (let i = 0; i < this.sidepanelStatusObject.length; i++) {
          if (this.filterStatusKey.length > 0) {
            this.filterStatusKey.forEach((key) => {
              if (typeof this.sidepanelStatusObject[i][key] === 'string' && typeof this.searchStatus === 'string') {
                if (this.sidepanelStatusObject[i][key].toString().toLowerCase().indexOf(this.searchStatus.toLowerCase()) > -1) {
                  const found = filterData.some(el => el.group_id === this.sidepanelStatusObject[i]['group_id']);
                  if (!found) {
                    filterData.push(this.sidepanelStatusObject[i]);
                  }
                }
              }
            });
          }
        }
      }
      this.sidepanelStatusData = filterData;
    }
    this.sortByGrouplist(this.sortItem);
  }
  //  clear search

  searchStatusClear() {
    this.searchStatus = "";
    this.sidepanelStatusData = this.sidepanelStatusObject;
    this.sortByGrouplist(this.sortItem);
    let filterdData = null;
    // this.mappingCategory();
  }

  // sortitem on change
  onChangeStatusSortItem(event, key) {
    this.sortByStatuslist(key);
  }
  sortByStatuslist(e) {
    this.sortStatusItem = e;
    let direction = 1;
    this.sidepanelStatusData.sort((a, b) => {
      if (a[e] < b[e]) {
        return -1 * direction;
      }
      else if (a[e] > b[e]) {
        return 1 * direction;
      }
      else {
        return 0;
      }
    });
  }
  editStatus(e) {
    this.broadcastInfo({ src: "sidepanel", event: "updateStatus", data: e })
  }
  selectedStatusDeleteData = {};
  OnDeleteStatus(i, item) {
    this.selectedStatusDeleteData = { i, item };
    this.broadcastInfo({ src: 'material', event: 'openDialogConfirmStatusDelete', data: "", key: true });
  }
  deleteStatusData() {
    this.broadcastInfo({ src: 'sidepanel', event: 'statusDelete', data: this.selectedStatusDeleteData, key: true });
  }
  onChangeStatusColor(item, event) {
    console.log(item)
    item.value = event;
    this.configService.updateStatus(item._id, item).then(data => {
      if (data) {
        console.log("Status updated ", data);
        this.broadcastInfo({ src: "sidepanel", event: "updateStatusColor", data: "statusReload" })
        this.broadcastInfo({ src: 'kys', event: 'updateStatusData', data: "reConstructTagJson" });
        this.broadcastInfo({ src: 'sidepanel', event: 'updateStatusColorData', data: "updateStatusColor" });
      }
    }).catch((error) => {
      console.log("error ", error);
    });
  }
  onChangeStatusColorClick(item) {
    this.StatusColorValue = item.value;
  }
  ToggleGameOpenHanddle() {
    this.shipGameHandleToggleOpen = !this.shipGameHandleToggleOpen;
    if (!this.shipGameHandleToggleOpen) {
      if (window.innerWidth > 541) {
      }
    }
    if (!this.shipGameHandleToggleOpen) {
      var elem = document.getElementsByClassName('side_panel');
      elem[0].classList.remove('open');
    } else {
    }
  }
  pathAnim
  startPathAnim(e) {
    if(this.pathAnim2){
      this.startPathAnim2({checked:false})
    }
    if(this.pathAnim3){
      this.startPathAnim3({checked:false})
    }
    this.pathAnim = !this.pathAnim;
    if (this.pathAnim) {
      // this.shipGameHandleToggleOpen = false;
    }
    this.broadcastInfo({ src: 'sidepanel', event: 'pathAnimMode', key: this.pathAnim });
    this.broadcastInfo({ src: 'sidepanel', event: 'pathAnim', key: this.pathAnim });
    this.broadcastInfo({ src: 'sidepanel', event: 'updateSettigns', data: e.checked });
    // if (e.checked == true) {
    //   this.shipGameHandleToggleOpen = false;
    // } else {
    //   this.shipGameHandleToggleOpen = true;
    // }
  }
  pathAnim2
  startPathAnim2(e) {
    if(this.pathAnim){
      this.startPathAnim({checked:false})
    }
    if(this.pathAnim3){
      this.startPathAnim3({checked:false})
    }
    this.pathAnim2 = !this.pathAnim2;
    if (this.pathAnim2) {
      // this.shipGameHandleToggleOpen = false;
    }
    this.broadcastInfo({ src: 'sidepanel', event: 'pathAnimMode', key: this.pathAnim2 });
    this.broadcastInfo({ src: 'sidepanel', event: 'pathAnim', key: this.pathAnim2, data: 'demo2' });
    this.broadcastInfo({ src: 'sidepanel', event: 'updateSettigns', data: e.checked });
    // if (e.checked == true) {
    //   this.shipGameHandleToggleOpen = false;
    // } else {
    //   this.shipGameHandleToggleOpen = true;
    // }
  }
  pathAnim3
  startPathAnim3(e) {
    if(this.pathAnim){
      this.startPathAnim({checked:false})
    }
    if(this.pathAnim2){
      this.startPathAnim2({checked:false})
    }   
    this.pathAnim3 = !this.pathAnim3;
    if (this.pathAnim3) {
      // this.shipGameHandleToggleOpen = false;
    }
    
    this.broadcastInfo({ src: 'sidepanel', event: 'pathAnimMode', key: this.pathAnim3 });
    this.broadcastInfo({ src: 'sidepanel', event: 'pathAnim', key: this.pathAnim3, data: 'demo3' });
    this.broadcastInfo({ src: 'sidepanel', event: 'updateSettigns', data: e.checked });
    // if (e.checked == true) {
    //   this.shipGameHandleToggleOpen = false;
    // } else {
    //   this.shipGameHandleToggleOpen = true;
    // }
  }
}

